const messages = {
  tr: {
    translations: {
      signup: {
        title: "Kayıt Ol",
        toasts: {
          success: "Kullanıcı başarılı bir şekilde oluşturuldu. Giriş Yapın!",
          fail: "Kullanıcı oluştururken hata oluştu."
        },
        form: {
          name: "Adınız",
          companyName: "Organizasyon Adı",
          email: "Eposta",
          phone: "Telefon",
          password: "Şifre"
        },
        buttons: {
          submit: "Kayıt",
          login: "Hesabınız var mı? Giriş Yapın."
        },
        plan: {
          title: "Planınızı Seçin",
          subtitle: "Şirketiniz için ideal planı seçin",
          badge: "Şirketiniz için ideal",
          period: "ay",
          meta: "{{users}} kullanıcıya kadar · {{connections}} bağlantıya kadar"
        },
        formStep: {
          title: "Hesabınızı oluşturun",
          subtitle: "Şirket bilgilerinizi doldurun"
        },
        verify: {
          title: "E-posta Doğrulama",
          subtitle: "Adresine gönderilen 6 haneli kodu girin",
          confirm: "Doğrula ve Hesap Oluştur",
          sending: "Gönderiliyor...",
          resend: "Kodu yeniden gönder",
          resendIn: "Yeniden gönder"
        },
        actions: {
          continue: "Devam",
          back: "Geri",
          hasAccount: "Zaten bir hesabınız var mı?",
          enter: "Giriş Yap"
        },
        document: {
          label: "Vergi No / Belge (isteğe bağlı)",
          cpfValid: "CPF geçerli!",
          cnpjValid: "CNPJ geçerli! Şirket adı otomatik dolduruldu.",
          invalid: "Geçersiz belge.",
          error: "Belge doğrulanırken hata oluştu."
        },
        validation: {
          required: "Zorunlu alan",
          nameMin: "Ad en az 2 karakter olmalı",
          nameMax: "Ad en fazla 50 karakter olmalı",
          companyMin: "Şirket en az 2 karakter olmalı",
          companyMax: "Şirket en fazla 50 karakter olmalı",
          passwordMin: "Şifre en az 5 karakter olmalı",
          passwordMax: "Şifre en fazla 50 karakter olmalı",
          invalidEmail: "Geçersiz e-posta",
          codeLength: "6 haneli kodun tamamını girin."
        },
        features: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram",
          campaigns: "Kampanyalar",
          schedules: "Randevular",
          internalChat: "Dahili Sohbet",
          externalApi: "Harici API",
          integrations: "Entegrasyonlar",
          openAi: "OpenAI",
          kanban: "Kanban"
        },
        recaptcha1: "This site is protected by reCAPTCHA and the Google",
        recaptcha2: "Privacy Policy",
        recaptcha3: "and",
        recaptcha4: "Terms of Service",
        recaptcha5: "apply."
      },
      passwordRecovery: {
        title: "Şifremi Unuttum",
        toasts: {
          success: "Eposta gönderildi, eposta adresinizi kontrol edin.",
          passwordUpdateSuccess: "Şifre Başarılı bir şekilde değiştirildi.",
          fail: "Şifre değiştirilirken hata oluştu. Tekrar deneyin."
        },
        form: {
          email: "Eposta",
          password: "Şifre",
          confirmPassword: "Şifre Tekrar",
          validation: "Şifrelerin eşleşmesi gerekiyor!"
        },
        buttons: {
          submit: "Gönder",
          login: "Giriş Yap"
        }
      },
      login: {
        title: "Giriş",
        form: {
          email: "Eposta",
          password: "Şifre"
        },
        buttons: {
          submit: "Gönder",
          register: "Hesabınız yok mu? Kayıt Ol!",
          recovery: "Şifremi Unuttum?"
        }
      },
      companies: {
        title: "Şirket Kaydet",
        form: {
          name: "Şirket Adı",
          plan: "Plan",
          token: "Token",
          submit: "Kaydet",
          success: "Şirket başarıyla oluşturuldu!",
        },
        confirmationModal: {
          deleteTitle: "Şirketi Sil",
          deleteMessage: "Bu şirketi silmek istediğinizden emin misiniz? Tüm ilgili veriler kaybolacaktır. Bu işlem geri alınamaz.",
        },
      },
      auth: {
        toasts: {
          success: "Giriş Başarılı!",
          active:
            "Hesap başarılı bir şekilde aktif edildi. Lütfen giriş yapın.",
          trialExpired: "Deneme süreniz bitti, bizimle iletişime geçiniz.",
          notActive:
            "Hesabınız aktif edilmedi, Lütfen eposta adresinizi doğrulayın."
        },
        dueDate: {
          expiration: "Aboneliğiniz sona eriyor",
          days: "gün!",
          day: "gün!",
          expirationToday: "Aboneliğiniz bugün sona eriyor!",
          warning: "Aboneliğiniz {{days}} {{unit}} içinde sona eriyor",
          expired: "Aboneliğiniz {{date}} tarihinde sona erdi. Daha fazla bilgi için Destek ile iletişime geçin!",
        },
      },
      dashboard: {
        charts: {
          perHour: {
            title: "Bugün - Sohbet Adeti: ",
            verticalTitle: "Sohbet"
          }
        }
      },
      connections: {
        title: "Bağlantı",
        integrity: "Bütünlük",
        stable: "Kararlı",
        unstable: "Kararsız",
        toasts: {
          deleted: "WhatsApp bağlantısı başarılı bir şekilde silindi!"
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage:
            "Silmek istediğinize emin misiniz? Bu işlem geri döndürülemez.",
          disconnectTitle: "Bağlantı Yok!",
          disconnectMessage:
            "Emin misiniz? QR Kodu yeniden okutmanız gerekecek."
        },
        buttons: {
          add: "WhatsApp Ekle",
          disconnect: "Bağlantıyı Sonlandır",
          tryAgain: "Tekrar Deneyin",
          qrcode: "QR Kodu",
          newQr: "Yeni QR Kodu",
          connecting: "Bağlantıyı Oluştur",
          start: "Başla"
        },
        toolTips: {
          disconnected: {
            title: "WhatsApp oturumu başlatılamadı!",
            content:
              "Telefonun İnternet bağlantısı ve şarj seviyesinin düşük olmadığından emin olunuz. Ya da QR Kodu yeniden oluşturunuz."
          },
          qrcode: {
            title: "QR Kodu okumasını bekleyiniz.",
            content:
              "'QR Kodu' butonuna tıklayın ve telefonunuzdan QR Kodu okutarak oturumu başlatın."
          },
          connected: {
            title: "Bağlantı Kuruldu."
          },
          timeout: {
            title: "Telefonunuzla olan bağlantı koptu!",
            content:
              "Telefonun İnternet bağlantısından, WhatsApp'ın arka planda da çalışır olduğundan ve şarj seviyesinin düşük olmadığından emin olunuz. Ya da QR Kodu yeniden oluşturunuz."
          },
          offline: {
            title: "Bağlantı kapalı",
            content: "Online olmak için başlayın."
          }
        },
        table: {
          name: "İsim",
          number: "Numara",
          status: "Durum",
          provider: "WhatsApp",
          default: "Varsayılan",
          actions: "İşlem",
          session: "Oturum"
        },
        nativeImport: {
          importing: "WhatsApp mesajları içe aktarılıyor...",
          finishing: "İçe aktarma tamamlanıyor...",
          processed: "İşlendi",
          messages: "mesaj",
          currentDate: "Geçerli tarih",
          errors: "hatalar",
          cancelled: "İçe aktarma iptal edildi",
          cancel: "İptal",
        },
        importProgress: {
          done: "İçe aktarma tamamlandı!",
          cancelled: "İçe aktarma iptal edildi",
          importing: "Mesajlar içe aktarılıyor...",
          starting: "Bağlanıyor...",
          scanning: "Sohbetler taranıyor...",
          processingChat: "Sohbet {{current}} / {{total}} işleniyor",
          allProcessed: "Tüm sohbetler işlendi",
          cancelledAt: "{{current}} / {{total}} sohbette durduruldu",
          initializing: "Başlatılıyor...",
          progress: "İlerleme",
          chats: "sohbet",
          messagesLabel: "Mesajlar",
          tickets: "Biletler",
          contacts: "Kişiler",
          errorsLabel: "Hatalar",
          cancelImport: "İçe Aktarmayı İptal Et",
          close: "Kapat",
        },
      },
      whatsappModal: {
        title: {
          add: "WhatsApp Ekle",
          edit: "WhatsApp'ı düzenle"
        },
        form: {
          name: "İsim",
          onNewMessage: "Yeni Bir Mesajda",
          greetingMessage: "Karşılama Mesajı",
          farewellMessage: "Kapanış Mesajı",
          alwaysReopen: "Her zaman önceki konuşmayı yeniden aç",
          customReopen1: "Önceki konuşmayı",
          customReopen2: "dakikaya kadar yeniden aç",
          farewellTooltip: {
            title: "Sohbet Kapatıldıktan sonra gönderilecek mesaj",
            content:
              "Eklemek için aşağıdaki değişkenlere tıklayabilirsiniz. Göndermemek için boş bırakın"
          }
        },
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal"
        },
        success: "WhatsApp başarılı bir şekilde kaydedildi."
      },
      qrCode: {
        message: "Oturumu başlatmak için QR Kodu okuyun."
      },
      qrcodeModal: {
        title: "WhatsApp'a Bağlan",
        subtitle: "Oturumu başlatmak için QR Kodu telefonunuzla tarayın",
        connected: "Başarıyla bağlandı!",
        generating: "Yeni QR Kodu oluşturuluyor...",
        step1: "Telefonunuzda <strong>WhatsApp</strong>'ı açın",
        step2Options: "<strong>Diğer seçenekler ⋮</strong> veya <strong>Ayarlar ⚙</strong>'a dokunun ve <strong>Bağlı Cihazlar</strong>'ı seçin",
        step3: "<strong>Cihaz Bağla</strong>'ya dokunun ve kamerayı bu QR Koduna yönlendirin",
        refreshCountdown: "QR Kodu {{seconds}} saniye içinde yenilenir",
        refreshing: "QR Kodu yenileniyor...",
      },
      fastResponses: {
        title: "Hızlı Yanıtlar",
        toasts: {
          deleted: "Hızlı yanıt başarılı bir şekilde silindi!"
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage: "Emin misiniz? Bu işlem geri döndürülemez."
        },
        buttons: {
          add: "Hızlı yanıt etkle"
        },
        table: {
          shortcut: "Kısayol",
          message: "Mesaj",
          actions: "Eylem"
        }
      },
      fastResponseModal: {
        title: {
          add: "Hızlı yanıt ekle",
          edit: "Hızlı yanıt düzenle"
        },
        form: {
          shortcut: "Kısayol",
          message: "Mesaj"
        },
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal"
        },
        success: "Hızlı yanıt başarılı bir şekilde kaydedildi."
      },
      help: {
        title: "Yardım Merkezi"
      },
      contacts: {
        title: "Kişiler",
        toasts: {
          deleted: "Kişi Başarılı bir şekilde silindi!",
          not_imported_beta:
            "WhatsApp Beta'da kişileri içe aktarmak mümkün değil"
        },
        searchPlaceholder: "Ara ...",
        confirmationModal: {
          deleteTitle: "Sil",
          importTitlte: "Kişileri Yükle",
          deleteMessage:
            "Kişiyi silmek istediğinize emin misiniz? İlgili kişiye ait tüm sohbetler silinecektir.",
          importMessage:
            "Tüm Kişileri telefonunuzdan yüklemek istediğinize emin misiniz?"
        },
        newTicketModal: {
          title: "Yeni Konuşma",
          message: "Sohbete Başlamak için bağlantı oluştur."
        },
        buttons: {
          import: "Kişileri Çek",
          add: "Kişi Ekle"
        },
        table: {
          name: "İsim",
          whatsapp: "WhatsApp",
          email: "Eposta",
          actions: "İşlemler"
        }
      },
      contactModal: {
        title: {
          add: "Kişi Ekle",
          edit: "Kişi Düzenle"
        },
        form: {
          mainInfo: "İletişim Bilgileri",
          extraInfo: "Ek Bilgiler",
          name: "İsim",
          number: "Whatsapp numarası",
          email: "Eposta",
          extraName: "Alan Adı",
          extraValue: "Değeri",
          treatmentName: "İletişim Nedeni",
          verified: "Onaylı",
          notVerified: "Onaylı Değiş"
        },
        buttons: {
          addExtraInfo: "Ekstra Bilgi Ekle ",
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal"
        },
        success: "Kişi Başarılı bir şekilde kaydedildi."
      },
      queueModal: {
        title: {
          add: "Kuyruk Oluştur",
          edit: "Kuyruk Düzenle"
        },
        form: {
          options: "Ayarlar",
          option: "Ayar",
          name: "İsim",
          color: "Renk",
          greetingMessage: "Karşılama Mesajı",
          responseMessage: "Yanıt:"
        },
        optionsTooltip: {
          title: "ChatBot için ayarları ekle",
          content:
            "Tek bir seçenek varsa, otomatik olarak seçilecek ve botun seçenek mesajıyla yanıt vermesini sağlayacak."
        },
        greetingTooltip: {
          title:
            "Mesaj zorunlu alan, düzenlemek için tıkla! Message is required, click here to edit!",
          content: "Mesajsız bir seçenek seçilmeyecek."
        },
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal",
          addOption: "Seçenek Ekle"
        },
        confirmationModal: {
          deleteTitle: "Seçeneği sil",
          deleteMessage: "Emin misiniz? Yapılan tüm seçenekler silinecek!"
        }
      },
      campaignModal: {
        title: {
          add: "Yeni Kampanya"
        },
        form: {
          name: "Kampanya Adı",
          connection: "Bağlantı",
          globalBody: "Varsayılan Mesaj",
          globalBodyTooltip:
            "Bu mesaj, tanımlanmış bir body'si olmayan CSV'deki içe aktarılan numaralara gönderilecektir."
        },
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal"
        },
        success: "Kampanya Başarılı şekilde eklendi.",
        apiOfficialNoFollowUp: "⚠️ Follow-up sadece (Não Oficial BLS) kanalları için kullanılabilir. Resmi API ile kampanyalarda sadece şablon gönderilir."
      },
      campaignProgressModal: {
        title: "Kampanya Mesajı",
        name: "Kampanya Adı",
        status: "Durum",
        table: {
          number: "Numara",
          message: "Mesaj",
          updatedAt: "Güncellendi",
          status: "Durum"
        },
        buttons: {
          back: "Geri"
        },
        ackLabels: {
          scheduled: "Ayarlandı",
          pending: "Gönderilmedi",
          sent: "Gönderildi",
          received: "Alındı",
          read: "Okundu"
        }
      },
      csvHandler: {
        downloadCsv: "Örnek Dosyayı İndir",
        importCsv: "CSV Dosyası Yükle"
      },
      userModal: {
        title: {
          add: "Kullanıcı Ekle",
          edit: "Kullanıcı Düzenle"
        },
        form: {
          name: "Ad",
          email: "Eposta",
          password: "Şifre",
          profile: "Profil"
        },
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal"
        },
        success: "Kullanıcı başarılı bir şekilde kaydedildi."
      },
      chat: {
        noTicketMessage:
          "Sohbete Başlamak için, herhangi bir sohbet kabul edin veya başlatın."
      },
      ticketsManager: {
        header: {
          title: "Sohbetler",
        },
        buttons: {
          newTicket: "Yeni"
        }
      },
      multipleSelectField: {
        selectAll: "Tümünü seç"
      },
      ticketsFilter: {
        applyFilters: "Uygula",
        cleanFilters: "Temizle",
        found: "Bulundu",
        placeholders: {
          search: "İsime veya numaraya göre ara",
          queues: "Kuyruklar",
          noQueue: "Sıra",
          whatsapps: "WhatsApp'lar",
          noWhatsapp: "Ne whatsapp",
          users: "Kullanıcılar",
          noUser: "Cevapsız",
          status: "Durumlar",
          protocol: "Protokol",
          tags: "Etiketler",
          dateFrom: "Başlangıç",
          dateTo: "Bitiş",
          pending: "Beklemek",
          open: "Katılmak",
          closed: "Çözüldü"
        }
      },
      ticketTagManager: {
        addTags: "Etiket Ekle",
        add: "Ekle",
        typeToAdd: "Yeni Etiket Yaz",
        confirmationModal: {
          deleteTitle: "Etiket Sil",
          deleteMessage:
            "Emin misiniz? Bu etiket ilgili tüm konuşmalardan silinecek!"
        }
      },
      referral: {
        title: "Referans Programı",
        link: "Referans Bağlantısı"
      },
      subscription: {
        title: "Abonelik",
        details: "Abonelik Detayları",
        billingEmail: "Fatura Eposta",
        unverifiedEmail1: "Bu eposta onaylanmamış, ",
        unverifiedEmailClick: "Buraya Tıkla ",
        unverifiedEmail2: "Aktivasyon mailini yeniden almak için.",
        status: {
          trial: "Deneme",
          active: "Aylık Abone",
          suspended: "Aboneliğin süresi doldu!"
        },
        expirationMessage: {
          trialExpiringIn: "Deneme sürenizin bitmesine {{count}} gün kaldı!!",
          trialExpiringIn_plural:
            "Deneme süreniz {{count}} gün içinde sona eriyor!",
          trialExpired:
            "Deneme süresi doldu, Kullanmak için aboneliğinizi yenileyin!",
          subscriptionCycleExpiring: "Mevcut aboneliğiniz sona eriyor."
        },
        planTable: {
          header: {
            plan: "Plan",
            users: "Kullanıcılar",
            whatsapps: "Whatsapplar",
            total: "Toplam",
            lastInvoice: "Son Fatura"
          },
          planName: "Özel"
        },
        buttons: {
          subscribe: "Abone Ol!",
          edit: "Değiştir",
          close: "Sonlandır"
        },
        tooltip: {
          billingCycle: {
            title: "Bir sonraki faturanızın son ödeme tarihi",
            content:
              "Fatura son ödeme tarihinden 10 gün önce düzenlenir. Aşağıdaki 'Son fatura' düğmesi aracılığıyla veya fatura e-postanız aracılığıyla faturaya erişin."
          }
        }
      },
      changeEmailModal: {
        title: "Fatura epostasını değiştirin",
        placeholder: "Yeni eposta",
        toast: "Yeni bir onay maili eposta adresinize gönderildi.",
        buttons: {
          ok: "Değiştir",
          cancel: "İptal"
        }
      },
      checkoutStepper: {
        titleEdit: "Planı Değiştir",
        titlePending: "Neredeyse Hazır!",
        titleDone: "Aboneliğiniz için Teşekkürler!",
        steps: {
          billingData: "Veri",
          customize: "Özelleştir",
          review: "Gözden Geçir",
          success: "Tebrikler!"
        },
        messages: {
          toastMinimumPlan: "En az 3 kullanıcı ve 1 whatsapp numarası gerekli",
          fieldMinimumUsers: "En Az 3!",
          fieldMinimumWhats: "En az 1!",
          emailSent:
            "Fatura adresine ödeme talimatı içeren bir e-posta gönderildi.",
          activationInfo:
            "Kredi kartı ödemeleri anında etkinleştirilir. Daha fazla yardıma ihtiyacınız olursa bizimle iletişime geçmekten çekinmeyin.",
          planChanged: "Aboneliğiniz güncellendi!",
          planChangedInfo:
            "Yeni kullanıcılar ve whatsapp limiti zaten mevcut. Yeni değer, bir sonraki açık faturanızda tahsil edilecektir."
        },
        buttons: {
          payNow: "Öde!",
          close: "Kapat"
        }
      },
      billingData: {
        title: "Gerekli Bilgiler",
        form: {
          name: "İsim",
          document: "Döküman Numarası",
          zip: "Posta Kodu",
          street: "Sokak",
          number: "Numara",
          district: "İlçe",
          complement: "Adres",
          city: "İl",
          state: "Ülke"
        }
      },
      planBuilder: {
        title: "Aboneliğinizi özelleştirin",
        table: {
          header: {
            item: "Ürün",
            quantity: "Miktar",
            unitaryValue: "Değer",
            subtotal: "Ara Toplam"
          },
          users: "Kullanıcılar",
          whatsapps: "Whatsapp'lar",
          total: "Toplam"
        },
        buttons: {
          next: "Sıradaki"
        }
      },
      subscriptionReview: {
        title: "Abonelik Özeti",
        titleChange: "Uyarı! Değişiklik 30 gün içerisinde değiştirilemez!",
        whatsExceeded:
          "Dikkat! Şu anda kullandığınızdan daha az whatsapp'a ayarlıyorsunuz. Fazla bağlantılar silinecek.",
        planDetails: "Plan Detayları",
        paymentDetails: "Ödeme Bilgisi",
        email: "Eposta",
        users: "Kullanıcılar",
        whatsapps: "Whatsapplar",
        name: "İsim",
        address: "Adres",
        document: "Döküman",
        total: "Toplam",
        buttons: {
          subscribe: "Abone Ol ",
          change: "Değişikliği Onayla",
          back: "Geri"
        }
      },
      tickets: {
        toasts: {
          deleted: "Oluşturulan sohbet silindi."
        },
        notification: {
          message: "Gelen Mesaj"
        },
        tabs: {
          open: { title: "Açık" },
          closed: { title: "Kapalı" },
          search: { title: "Ara" }
        },
        buttons: {
          showAll: "Tüm"
        }
      },
      transferTicketModal: {
        title: "Sohbeti Transfer Et",
        fieldLabel: "Kullanıcı Ara",
        noOptions: "Bu isimde Kullanıcı Bulunamadı.",
        noteLabel: "Gözlemler",
        buttons: {
          ok: "Transfer",
          cancel: "İptal"
        }
      },
      ticketsList: {
        pendingHeader: "Kuyruktakiler",
        assignedHeader: "İlgilenilenler",
        groupingHeader: "Gruplar",
        elapsedPrefix: "{{distance}} önce",
        missedCall: "Kaçırılan sesli/görüntülü arama",
        noTicketsTitle: "Boş!",
        noTicketsMessage: "Aranan terimle alakalı hiçbir şey bulunamadı.",
        buttons: {
          accept: "Kabul Et"
        },
        confirmationModal: {
          title: "Otomatik Yanıtlama",
          message:
            "Bu konuşma otomatik yanıtlamada. Kabul etmek, otomatik yanıtlamanın kesilmesine neden olur."
        },
        status: {
          closed: "Kapandı"
        }
      },
      ticketListItem: {
        assignedTo: "İlgilenen",
        waitingWarning: "5 dakikadan fazla bekliyor!",
        noQueue: "sıra yok",
        connectionTooltip: {
          title: "Bir bağlantı seçmek için tıklayın"
        },
        chatbotTooltip: {
          title: "Otomatik Yanıtlama"
        },
        selectWhatsModal: {
          title: "Bu görüşmenin bağlantısı yok",
          message: "Sohbete devam etmek için bir bağlantı seçin",
          applyToAll: "Bağlantı olmadan herkese uygula"
        }
      },
      newTicketModal: {
        title: "Sohbet Oluştur",
        fieldLabel: "Kişileri Ara",
        queues: "Kuyruklar",
        noQueue: "Boş",
        add: "Ekle",
        buttons: {
          ok: "Başla",
          cancel: "İptal"
        }
      },
      whatsappSelect: {
        label: "Bağlantı Seç*"
      },
      mainDrawer: {
        listItems: {
          dashboard: "Pano",
          connections: "Bağlantılar",
          tickets: "Sohbetler",
          contacts: "Kişiler",
          help: "Yardım",
          fastResponses: "Hızlı Yanıtlamalar",
          queues: "Kuyruklar & Chatbotlar",
          administration: "Yönetim",
          users: "Kullanıcılar",
          api: "API",
          apiKeys: "Tokens",
          apiDocs: "Dökümanlar",
          subscription: "Abonelik",
          campaigns: "Kampanyalar",
          referral: "Referans",
          settings: "Ayarlar",
          automations: "Otomasyonlar",
          groupManager: "Grup Yöneticisi",
          tasks: "Görevler",
          followUp: "Takip (Şablonlar)",
          salesPipeline: "Satış Hattı",
          salesPipelineDesc: "Fırsatları görüntüle",
          taskList: "Görev Listesi",
          taskListDesc: "Planla ve yönet",
          preferences: "Tercihler",
          preferencesDesc: "Sistem ayarları",
          switchAccount: "Hesap Değiştir",
          switchAccountDesc: "Kayıtlı hesapları yönet",
        },
        planExpiresToday: "⚠️ Planınız bugün sona eriyor! Erişiminizi kaybetmemek için şimdi yenileyin.",
        planExpiresTomorrow: "⚠️ Planınız yarın sona eriyor! Erişiminizi kaybetmemek için yenileyin.",
        planExpiresIn: "⏳ Planınız {{count}} gün içinde sona eriyor. Sistemi kullanmaya devam etmek için yenileyin.",
        renewNow: "Şimdi yenile",
        appBar: {
          user: {
            profile: "Profil",
            logout: "Çıkış",
            switchAccount: "Hesap Değiştir"
          }
        }
      },
      notifications: {
        title: "Bildirimler", clearAll: "Tümünü temizle",
        noTickets: "Bildirim Yok."
      },
      queues: {
        title: "Kuyruklar",
        deleteQueue: "Sıra başarıyla silindi.",
        saveQueue: "Sıra başarıyla kaydedildi!",
        table: {
          name: "İsim",
          color: "Renk",
          greeting: "Karşılama mesajı",
          actions: "İşlemler"
        },
        buttons: {
          add: "Kuyruk Ekle"
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage:
            "Silmek istediğinize emin misiniz? Bu kuyruktaki sohbetler hala var olacak, ancak atanmışlar herhangi bir sıraya sahip olmayacak!"
        }
      },
      queueSelect: {
        inputLabel: "Kuyruklar"
      },
      users: {
        title: "Kullanıcılar",
        table: {
          name: "İsim",
          email: "Eposta",
          profile: "Profil",
          actions: "İşlemler",
          no_data: "Veri yok"
        },
        buttons: {
          add: "Kullanıcı Ekle"
        },
        toasts: {
          deleted: "Kullanıcı Başarılı bir şekilde silindi."
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage:
            "Tüm kullanıcı verileri silinecek. Kullanıcıların açık sohbetleri kuyruğa taşınacaktır."
        },
        totalCountUsers: "Toplam Kullanıcılar :"
      },
      campaigns: {
        title: "Kampanyalar",
        searchPlaceholder: "Ara",
        subMenus: {
          list: "Listeleme",
          listContacts: "Kişi Listesi",
          settings: "Ayarlar",
        },
        settings: {
          randomInterval: "Rastgele Gönderim Aralığı",
          noBreak: "Aralık Yok",
          intervalGapAfter: "Sonrasında daha uzun aralık",
          undefined: "Tanımsız",
          messages: "mesajlar",
          laggerTriggerRange: "Daha Büyük Gönderim Aralığı",
          addVar: "Değişken Ekle",
          save: "Kaydet",
          close: "Kapat",
          add: "Ekle",
          shortcut: "Kısayol",
          content: "İçerik",
        },
        buttons: {
          add: "Yeni Kampanya",
          contactLists: "Kişi Listeleri",
        },
        table: {
          name: "Ad",
          whatsapp: "Bağlantı",
          contactList: "Kişi Listesi",
          option: "Hiçbiri",
          disabled: "Devre Dışı",
          enabled: "Etkin",
          status: "Durum",
          scheduledAt: "Planlanan",
          completedAt: "Tamamlanan",
          confirmation: "Onay",
          actions: "İşlemler",
          recurrence: "Tekrarlama",
          nextExecution: "Sonraki Yürütme",
        },
        dialog: {
          new: "Yeni Kampanya",
          update: "Kampanyayı Düzenle",
          readonly: "Sadece Görüntüle",
          help: "Değişkenleri kullanın: {ad}, {numara}, {email} veya özel değişkenler tanımlayın.",
          form: {
            name: "Ad",
            message1: "Mesaj 1",
            message2: "Mesaj 2",
            message3: "Mesaj 3",
            message4: "Mesaj 4",
            message5: "Mesaj 5",
            confirmationMessage1: "Onay Mesajı 1",
            confirmationMessage2: "Onay Mesajı 2",
            confirmationMessage3: "Onay Mesajı 3",
            confirmationMessage4: "Onay Mesajı 4",
            confirmationMessage5: "Onay Mesajı 5",
            messagePlaceholder: "Mesaj içeriği",
            whatsapp: "Bağlantı",
            status: "Durum",
            scheduledAt: "Planlama",
            confirmation: "Onay",
            contactList: "Kişi Listesi",
            tagList: "Etiketler",
            statusTicket: "Bilet Durumu",
            openTicketStatus: "Açık",
            pendingTicketStatus: "Beklemede",
            closedTicketStatus: "Kapalı",
            enabledOpenTicket: "Etkin",
            disabledOpenTicket: "Devre Dışı",
            openTicket: "Bilet Aç",
          },
          buttons: {
            add: "Ekle",
            edit: "Güncelle",
            okadd: "Tamam",
            cancel: "Gönderimi İptal Et",
            restart: "Gönderimi Yeniden Başlat",
            close: "Kapat",
            attach: "Dosya Ekle",
          },
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage: "Bu işlem geri alınamaz.",
        },
        statuses: {
          inactive: "İnaktif",
          scheduled: "Planlanmış",
          inProgress: "Devam Ediyor",
          cancelled: "İptal Edildi",
          finished: "Tamamlandı",
        },
        recurrence: {
          minutely: "Dakikada",
          hourly: "Saatte",
          daily: "Günlük",
          weekly: "Haftalık",
          biweekly: "İki Haftalık",
          monthly: "Aylık",
          yearly: "Yıllık",
        },
        stopRecurrence: {
          title: "Tekrarlamayı Durdur",
          message: "Bu kampanyanın tekrarlamasını durdurmak istediğinizden emin misiniz? Mevcut kampanya çalışmaya devam edecek, ancak gelecek yürütmeler olmayacak.",
        },
        filters: {
          status: "Durum",
          all: "Tümü",
          allFem: "Tümü",
          recurrence: "Tekrarlama",
          recurring: "Tekrarlayan",
          single: "Tek Seferlik",
        },
        tooltips: {
          recurring: "Tekrarlayan Kampanya",
          stop: "Kampanyayı Durdur",
          restart: "Kampanyayı Yeniden Başlat",
          stopRecurrence: "Tekrarlamayı Durdur",
          duplicate: "Kampanyayı Kopyala",
          export: "CSV Dışa Aktar",
          preview: "Mesaj önizleme",
        },
        summary: {
          total: "Toplam",
          scheduled: "Planlanmış",
          inProgress: "Devam Ediyor",
          finished: "Tamamlandı",
          cancelled: "İptal Edildi",
        },
        bulk: {
          selected: "seçili",
          cancelAll: "İptal Et",
          restartAll: "Yeniden Başlat",
          deleteAll: "Sil",
          confirmTitle: "Toplu İşlem",
          confirmMessage: "{{count}} kampanya üzerinde bu işlemi gerçekleştirmek istediğinizden emin misiniz?",
        },
        noMessage: "Mesaj yok",
        not_connection: "Bağlantı Yok",
        listRemoved: "Bağlı liste yok",
        connectionDeleted: "Bağlantı silindi",
        connectionPrefix: "Bağlantı",
        noConnection: "Bağlantı yok",
        notCompleted: "Tamamlanmadı",
        totalLabel: "kampanya",
        pagination: {
          rowsPerPage: "Sayfa başına satır:",
          of: "/",
          moreThan: "fazlası",
        },
        toasts: {
          success: "İşlem başarıyla tamamlandı.",
          cancel: "Kampanya iptal edildi.",
          restart: "Kampanya yeniden başlatıldı.",
          deleted: "Kayıt silindi.",
          duplicated: "Kampanya başarıyla kopyalandı!",
          bulkSuccess: "Toplu işlem başarıyla tamamlandı!",
          noPermission: "Bu şirketin bu sayfaya erişim izni yok! Yönlendiriliyorsunuz.",
          recurrenceStopped: "Tekrarlama başarıyla durduruldu!",
          created: "Kampanya başarılı bir şekilde oluşturuldu!",
          started: "Kampanya başarılı bir şekilde başladı!",
          suspended: "Kampanya başarılı bir şekilde durduruldu!",
        },
        remainingMessages: "Kalan Mesajlar:",
      },
      settings: {
        success: "Ayarlar başarılı bir şekilde kaydedildi!",
        title: "Ayarlar",
        settings: {
          language: "Otomatik olarak oluşturulan mesajların dili",
          timezone: "Zaman dilimi"
        }
      },
      messagesList: {
        header: {
          assignedTo: "İlgilenen :",
          buttons: {
            return: "Kuyruğa Al",
            resolve: "Kapat",
            reopen: "Yeniden Aç",
            accept: "Kabul"
          }
        }
      },
      contactMessage: {
        add: "Ekle"
      },

      messageMedia: {
        loading: "Yükleniyor..."
      },
      messagesInput: {
        maxUploadSize: "Yüklenen dosya 20 MB sınırını aşıyor",
        placeholder: {
          open: "Hızlı yanıt vermek için bir mesaj veya ' / ' yazın",
          closed: "Mesaj göndermek için bu bileti yeniden açın veya kabul edin",
          note: "Özel not ekle"
        },
        signMessage: "Unvan",
        dragAndDrop: "Dosya eklemek için sürükleyip bırakın",
        tooltips: {
          sendNote: "Özel not",
          sendMessage: "Açık Mesaj"
        }
      },
      messagesInputExtra: {
        internalMessage: "Dahili mesaj",
        placeholderPending: "Bekleyen biletler için bir mesaj yazın",
        placeholderPendingAccept: "Mesaj göndermek için bu bileti kabul edin veya yeniden açın.",
        placeholderWindowExpired: "24 saat penceresi dışında. Mesaj göndermek için bir şablon kullanın.",
        ticketPendingTitle: "Bekleyen bilet.",
        ticketPendingMessage: "Yanıtlamak için bu bileti kabul edin veya yeniden açın.",
        flowProcessingTitle: "Akış Çalışıyor:",
        flowProcessingMessage: "Mesaj alanı geçici olarak devre dışı.",
        windowExpiredTitle: "24 Saat Penceresi Sona Erdi:",
        windowExpiredMessage: "Bir şablon göndermenizi öneririz, ancak normal şekilde de yazabilirsiniz.",
      },
      contactDrawer: {
        header: "Kullanıcı Detayları",
        buttons: {
          edit: "Kullanıcı Düzenle"
        },
        extraInfo: "Diğer Bilgiler"
      },
      ticketOptionsMenu: {
        delete: "Sil",
        transfer: "Transfer",
        confirmationModal: {
          title: "Sohbeti Sil #",
          message: "Dikkat! Konuşmayla ilgili tüm mesajlar kaybolacak."
        },
        buttons: {
          delete: "Sil",
          cancel: "İptal"
        },
        aiSummarize: "Yapay Zeka Görüşme Özeti",
        aiSummarizeTitle: "Yapay Zeka Görüşme Özeti",
        aiSummaryCopied: "Özet panoya kopyalandı!",
        aiSummaryCopy: "Kopyala",
        aiSummaryClose: "Kapat",
        aiSummarySaveNote: "Not Olarak Kaydet",
        aiSummarySaved: "Özet kişi notu olarak kaydedildi!",
        autoAiSummary: "Kapatıldığında otomatik AI özeti",
      },
      confirmationModal: {
        buttons: {
          confirm: "Tamam",
          cancel: "İptal"
        }
      },
      promptModal: {
        form: {
          name: "Ad",
          prompt: "Prompt",
          voice: "Ses",
          max_tokens: "Yanıtta Maksimum Token",
          temperature: "Sıcaklık",
          apikey: "API Anahtarı",
          max_messages: "Geçmişteki Maksimum Mesaj",
          voiceKey: "Ses API Anahtarı",
          voiceRegion: "Ses Bölgesi",
        },
        success: "Ajan başarıyla kaydedildi!",
        title: {
          add: "Ajan Oluştur",
          edit: "Ajanı Düzenle",
        },
        subtitle: "Yapay zeka ajanı parametrelerini yapılandırın",
        buttons: {
          okAdd: "Ekle",
          okEdit: "Kaydet",
          cancel: "İptal",
        },
        tabs: {
          basic: "Temel",
          behavior: "Davranış",
          advanced: "Gelişmiş",
          knowledge: "📚 Bilgi Tabanı",
          test: "🧪 Test",
        },
        basic: {
          agentName: "Ajan Adı *",
          agentNamePlaceholder: "Örn: Satış Asistanı",
          function: "İşlev",
          voiceTone: "Ses Tonu",
          aiModel: "Yapay Zeka Modeli",
          apiKey: "API Anahtarı *",
          responseLanguages: "🌐 Yanıt Dilleri",
          responseLanguagesHelp: "Yapay zekanın yanıt verebileceği dilleri seçin. Müşterinin dilinde otomatik yanıt vermek için \"Otomatik\" kullanın.",
          personality: "Kişilik",
          personalityPlaceholder: "Ajanın kişiliğini, bilgisini ve becerilerini tanımlayın",
          personalityHelp: "Ajanın kişiliğini, bilgisini ve becerilerini tanımlayın",
          activeAgent: "Aktif Ajan",
        },
        behavior: {
          greetingMessage: "Karşılama Mesajı (isteğe bağlı)",
          greetingPlaceholder: "Merhaba! Size nasıl yardımcı olabilirim?",
          greetingHelp: "Ajan bir sohbet başlattığında otomatik olarak gönderilen mesaj",
          responseRules: "Yanıt Kuralları",
          responseRulesPlaceholder: "Ajanın uyması gereken belirli kuralları listeleyin",
          responseRulesHelp: "Ajanın uyması gereken belirli kuralları listeleyin",
          allowTransfer: "Görevliye transfer izni ver",
          transferKeywords: "Transfer anahtar kelimeleri",
          transferKeywordsPlaceholder: "görevli, çıkış, insanla konuş, insan",
          transferKeywordsHelp: "Virgülle ayırın. Tespit edildiğinde yapay zeka bir görevliye transfer eder",
          transferKeywordsDefault: "görevli, çıkış, insanla konuş, insan",
          transferMessage: "Transfer mesajı",
          transferMessagePlaceholder: "Üzgünüm, bu konu hakkında bilgim yok. Sizi bir görevliye aktarıyorum.",
          transferMessageDefault: "Üzgünüm, bu konu hakkında bilgim yok. Sizi bir görevliye aktarıyorum.",
        },
        advanced: {
          responseDelay: "Yanıt Gecikmesi",
          responseDelayHelp: "Yanıt göndermeden önce bekleme süresi (yazma simülasyonu)",
          charLimit: "Karakter sınırı",
          charLimitHelp: "Ajan yanıtının maksimum boyutu",
          humanize: "✨ Sohbeti insancıllaştır",
          humanizeHelp: "Doğal görünmesi için ad, tam ad ve adsız arasında geçiş yapar",
          audioFeatures: "🔊 Ses Özellikleri",
          transcribeAudio: "Gelen sesleri yazıya çevir",
          transcribeAudioHelp: "Ajanın anlaması için sesli mesajları metne dönüştürür",
          responseMode: "Yanıt Modu",
          agentVoice: "Ajan Sesi",
          sendAsPTT: "Kaydedilmiş ses olarak gönder (PTT)",
          sendAsPTTHelp: "Ses, WhatsApp sesi gibi o anda kaydedilmiş gibi görünür",
          temperatureHelp: "0 = kesin, 2 = yaratıcı",
          maxTokens: "Maks Token",
          maxMessages: "Maks Mesaj",
        },
        knowledge: {
          title: "Bilgi Tabanı",
          subtitle: "Ajanın referans olarak kullanması için metin, URL, PDF, ses ve video ekleyin",
          upload: "Yükle",
          add: "Ekle",
          saveFirst: "Bilgi tabanına öğe eklemek için önce ajanı kaydedin",
          newItem: "Yeni Öğe",
          nameLabel: "Ad",
          textType: "📋 Metin",
          urlType: "🔗 URL",
          urlLabel: "Site URL'si",
          textLabel: "Metin içeriği",
          urlPlaceholder: "https://ornek.com/sayfa",
          textPlaceholder: "Referans metni buraya yapıştırın...",
          cancelBtn: "İptal",
          saveBtn: "Kaydet",
          empty: "Bilgi tabanında öğe yok",
          emptyHelp: "Metin, URL ekleyin veya dosya yükleyin",
          noContent: "İçerik yok",
          fillNameContent: "Ad ve içeriği doldurun",
          addedSuccess: "Öğe bilgi tabanına eklendi!",
          uploadSuccess: "Dosya başarıyla yüklendi!",
          removeConfirm: "Bu öğeyi kaldırmak istediğinizden emin misiniz?",
          removeSuccess: "Öğe kaldırıldı!",
        },
        test: {
          model: "Model",
          usingApiKey: "\"Temel\" sekmesinden API Anahtarı ve prompt kullanılıyor",
          clear: "Temizle",
          emptyChat: "💬 Yapay Zeka Ajanınızı test etmek için bir mesaj gönderin",
          placeholder: "Test mesajınızı yazın...",
          fillApiKey: "Test etmeden önce API Anahtarını doldurun",
          fillPrompt: "Test etmeden önce kişilik/prompt doldurun",
          fillApiKeyVoice: "Ses önizleme için Temel sekmesinde API Anahtarını doldurun",
          voiceError: "Ses önizleme oluşturulurken hata. API Anahtarını kontrol edin.",
        },
        functions: {
          geral: "Genel",
          geralDesc: "Çok amaçlı asistan",
          vendas: "Satış",
          vendasDesc: "Dönüşüme odaklı",
          suporte: "Destek",
          suporteDesc: "Teknik destek",
          agendamento: "Randevu",
          agendamentoDesc: "Zaman planlama",
          financeiro: "Finans",
          financeiroDesc: "Tahsilat ve ödemeler",
        },
        voiceTones: {
          amigavel: "😊 Dostça",
          profissional: "💼 Profesyonel",
          formal: "🎩 Resmi",
          casual: "😎 Günlük",
          empatico: "🤗 Empatik",
          tecnico: "🔧 Teknik",
        },
        responseModes: {
          text: "Sadece Metin",
          textDesc: "Sadece metinle yanıt verir",
          audio: "Sadece Ses",
          audioDesc: "Sadece sesle yanıt verir",
          both: "Metin ve Ses",
          bothDesc: "Her ikisiyle de yanıt verir",
        },
        agentVoices: {
          alloyDesc: "Nötr ve dengeli",
          ashDesc: "Erkek, yumuşak",
          balladDesc: "Kadın, ifadeli",
          coralDesc: "Kadın, net",
          echoDesc: "Erkek, derin",
          fableDesc: "Erkek, İngiliz",
          onyxDesc: "Erkek, kalın",
          novaDesc: "Kadın, enerjik",
          sageDesc: "Erkek, sakin",
          shimmerDesc: "Kadın, zarif",
        },
        aiModels: {
          gpt4oMiniDesc: "Önerilen - Hız ve kalite dengesi",
          gpt4oDesc: "Daha akıllı ve detaylı",
          gpt41MiniDesc: "Hızlı ve verimli",
          gpt41Desc: "Yüksek performans",
          gpt41NanoDesc: "Ultra hızlı ve ekonomik",
          o4MiniDesc: "Gelişmiş akıl yürütme modeli",
        },
        sectorRequired: "Bir transfer sektörü seçin",
      },
      prompts: {
        title: "Yapay Zeka Ajanı",
        table: {
          name: "Ad",
          queue: "Sektör/Kuyruk",
          max_tokens: "Yanıtta Maksimum Token",
          tokens_used: "Kullanılan Tokenler",
          actions: "İşlemler",
        },
        metrics: {
          title: "Token Kullanım Metrikleri",
          totalTokens: "Toplam Token",
          inputTokens: "Giriş Tokenleri",
          outputTokens: "Çıkış Tokenleri",
          estimatedCost: "Tahmini Maliyet (USD)",
          costTooltip: "GPT-4o-mini ortalama fiyatlarına dayalı tahmin. Gerçek maliyet değişebilir.",
          perAgent: "Ajan Başına Tüketim",
        },
        confirmationModal: {
          deleteTitle: "Sil",
          deleteMessage: "Emin misiniz? Bu işlem geri alınamaz!",
        },
        buttons: {
          add: "Ajan Ekle",
        },
      },
      messageOptionsMenu: {
        delete: "Sil",
        reply: "Yanıtla",
        react: "Tepki Ver",
        reactionSent: "Tepki gönderildi",
        confirmationModal: {
          title: "Mesajı Sil?",
          message: "Bu işlem geri döndürülemez."
        }
      },
      maxUsersModal: {
        title: "Maksimum eşzamanlı kullanıcıya ulaşıldı!",
        subtitle:
          "Mevcut çevrimiçi kullanıcılar sözleşmeli kullanıcıları aştı, uygulamayı kullanmaya devam etmek için bir kullanıcının bağlantısını kesin.",
        table: {
          name: "İsim",
          lastSeen: "Son Görülme"
        },
        buttons: {
          disconnect: "Bağlantıyı Kes",
          logout: "Çıkış"
        },
        confirmationModal: {
          title: "Emin misiniz?",
          message: "Bağlantınız kesilecek."
        }
      },
      copyToClipboard: {
        copy: "Kopyala",
        copied: "Kopyalandı!"
      },
      retryMessageIcon: {
        error: "Mesaj gönderilirken hata oluştu. Yeniden denemek için tıklayın",
        loading: "Mesaj yeniden gönderiliyor..."
      },
      scheduledMessageIcon: {
        tooltip: "API'den gönderilmek üzere planlanmış mesaj"
      },
      sentFromApiIcon: {
        tooltip: "API'dan gönderildi"
      },
      messageVariablesPicker: {
        label: "Kullanılabilir Değişkenler",
        vars: {
          contactTreatment: "Kişi Sorunu",
          contactName: "Kişi İsmi",
          protocolNumber: "Protokol Numarası",
          contactNumber: "Kişi Numarası",
          greeting: "Karşılama"
        }
      },
      tokens: {
        title: "API Tokens",
        subtitle: "API Tokenlarını yönet",
        description:
          "Uygulama ile entegre etmek için tokenları kullanabilirsiniz. Bu API'yi kullanma hakkında daha fazla bilgi için Dokümanlar'ı ziyaret edin",
        table: {
          name: "İsim",
          secret: "Anahtar",
          actions: "İşlemler"
        },
        toasts: {
          tokenDeleted: "Token başarılı bir şekilde silindi!"
        },
        confirmationModal: {
          title: "Emin misiniz?",
          content:
            "Bu token'ı kullanan tüm sistemler yeniden yapılandırılmalıdır, aksi takdirde artık çalışmayacaktır.."
        },
        buttons: {
          new: "Yeni token"
        }
      },
      apiTokenModal: {
        title: "Token",
        name: "İsim",
        secret: "Anahtar",
        permissions: "İzinler",
        buttons: {
          save: "Kaydet",
          cancel: "İptal"
        },
        toasts: {
          noPermissions: "En az bir izin gereklidir.",
          success: "Token başarılı bir şekilde oluşturuldu!"
        }
      },
      initialConfig: {
        title: "İlk ayar",
        content1: "Whaticket 😊'a Hoşgeldiniz",
        content2:
          "Bunu kolaylaştırmak için * Hayatın, otomatik bir başlangıç ​​konfigürasyonu sağlıyoruz, böylece tüm Whaticket * * İnanılmaz * özelliklerini birkaç dakika içinde test edebilirsiniz.",
        content3:
          "* Tamam * tıklatarak, bir miktar * kuyruklar *, * chatbots *, * Hızlı Yanıtlar *, * Etiketler * ve A * WhatsApp bağlantısını oluşturalım. Bundan sonra, sadece sayfa * bağlantılardaki * QR kodunu * okuyun * bağlantılar * Testlere başlamak için. ",
        content4:
          "Bağlı sayıda ilk mesajı alır almaz, Whaticket eyleme geçecektir. 😎",
        content5:
          "Bütün bunları tek başına nasıl ayarlayacağınızı bilmek istiyorsanız, * Yardım * sayfasındaki videoları izleyebilir veya * Destek * ile temasa geçebilirsiniz.",
        content6: "İyi Testler! 🥰🥰"
      },
      languages: {
        undefined: "Dilim",
        "pt-BR": "Português",
        es: "Español",
        en: "English",
        tr: "Türkçe"
      },
      errorFallback: {
        error: "Uups, birşeyler yanlış gitti!",
        instructions: "Lütfen F5 yaparak sayfayı yenileyin ve tekrar deneyin!"
      },
      serviceWorker: {
        toast: "Yeni versiyon mevcut. Güncellemek için Tıklayın!"
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP:
          "En az bir tane WhatsApp bağlantısı olmak zorunda.",
        ERR_NO_DEF_WAPP_FOUND:
          "Varsayılan bir WhatsApp Hesabı bulunamadı. Lütfen Bağlantı sayfasını kontrol edin.",
        ERR_WAPP_NOT_INITIALIZED:
          "WhatsApp Oturumu başlatılamadı. Lütfen Bağlantı sayfasını kontrol edin.",
        ERR_WAPP_CHECK_CONTACT:
          "WhatsApp kişileri getirilemedi. Lütfen Bağlantı sayfasını kontrol edin.",
        ERR_WAPP_INVALID_CONTACT: "Bu uygun bir WhatsApp numarası gözükmüyor.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Medya indirilemedi. Lütfen Bağlantı sayfasını kontrol edin.",
        ERR_INVALID_CREDENTIALS: "Doğrulama Hatası. Lütfen Tekrar deneyiniz.",
        ERR_SENDING_WAPP_MSG:
          "Mesaj gönderilirken hata oluştu. Lütfen Bağlantı sayfasını kontrol edin.",
        ERR_DELETE_WAPP_MSG: "Mesaj Silinemiyor!",
        ERR_OTHER_OPEN_TICKET:
          "Bu kişi ile zaten açık bir sohbetiniz bulunmakta.",
        ERR_SESSION_EXPIRED: "Oturum sonlandı. Lütfen Giriş Yapın.",
        ERR_USER_CREATION_DISABLED:
          "Kullanıcı oluşturulması yönetici tarafından engellendi.",
        ERR_NO_PERMISSION: "Bu kaynağa erişmek için yetkiniz yok.",
        ERR_DUPLICATED_CONTACT: "Bu numaraya ait bir kişi zaten mevcut.",
        ERR_NO_SETTING_FOUND: "Bu ID'ye ait bir ayar bulunamadı!",
        ERR_NO_CONTACT_FOUND: "Bu ID'ye ait bir kişi bulunamadı!",
        ERR_DUPLICATED_EMAIL: "Bu eposta zaten kayıtlı!",
        ERR_NO_TICKET_FOUND: "Bu ID'ye aiit bir sohbet bulunamadı!",
        ERR_NO_USER_FOUND: "Bu ID'ye ait bir kullanıcı bulunamadı!",
        ERR_DIFFERENT_PASSWORDS: "Farklı Şifreler",
        ERR_RECOVERY_EXPIRED: "Yenileme süresi doldu.",
        ERR_NO_EMAIL_FOUND: "Bu Eposta ile kullanıcı bulunamadı.",
        ERR_NO_WAPP_FOUND: "Bu ID ile WhatsApp bulunamadı.",
        ERR_CREATING_MESSAGE: "Veritabanında mesaj oluşturulurken hata oluştu.",
        ERR_MAX_WHATS_REACHED:
          "İzin verilen maksimum whatsapp hesaplarına ulaşıldı, satış ekibiyle iletişime geçin.",
        ERR_MAX_WHATS_EXCEEDED:
          "İzin verilen maksimum whatsapp hesabı aşıldı! Uygulamayı kullanmaya devam etmek için bazı bağlantıları kaldırın.",
        ERR_CREATING_TICKET: "Veritabanında sohbet oluşturulurken hata oluştu.",
        ERR_FETCH_WAPP_MSG:
          "WhatsApp'ta mesaj alınırken hata oluştu, mesaj çok eski olabilir.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Bu renk zaten kullanılıyor, başka bir tane seçin.",
        ERR_QUEUE_INVALID_COLOR: "Bu renk geçersiz.",
        ERR_WAPP_GREETING_REQUIRED:
          "Birden fazla kuyruk varsa karşılama mesajı gereklidir.",
        ERR_MAX_USERS_REACHED:
          "Maksimum eşzamanlı kullanıcı sayısına ulaşıldı.",
        ERR_TICKET_NO_WHATSAPP:
          "Bir bağlantı atamak için konuşma listesini kontrol edin.",
        ERR_CANT_IMPORT_MSGS:
          "İçe aktarmaya yalnızca kişinin ilk konuşmasında izin verilir",
        ERR_NOT_WHATSAPPS_ONLINE:
          "Kişileri eklemek veya güncellemek için çevrimiçi bağlantı gereklidir. Bağlantılar sayfasını kontrol edin",
        ERR_CANNOT_EDIT_GROUPS: "Grup kişilerini düzenlemeye izin verilmiyor",
        ERR_ACCOUNT_DISABLED:
          "Hesabınız devre dışı bırakıldı, daha fazla bilgi için bizimle iletişime geçin ",
        ERR_TAG_INVALID_NAME:
          "Etiket adı en az iki karakter uzunluğunda olmalıdır",
        ERR_FASTRESP_SHORTCUT_ALREADY_EXISTS:
          "Bu kısayolla hızlı bir yanıt zaten var",
        ERR_TAG_ALREADY_EXISTS: "Bu ada sahip bir etiket zaten var",
        ERR_SUBSCRIPTION_EXPIRED:
          "Aboneliğinizin süresi doldu. Abonelik sayfasını kontrol edin",
        ERR_PLAN_CHANGED_RECENTLY:
          "30 gün içinde birden fazla değişikliğe izin verilmez.",
        ERR_CEP_NOT_FOUND: "Posta kodu bulunamadı. Adresi manuel olarak girin",
        ERR_NUMBER_IS_NOT_VERIFIED:
          "Kişi doğrulanmadı, numarayı kontrol edin ve tekrar deneyin.",
        ERR_DUPLICATED_CONTACT_NINTH:
          "Bu numaraya ait bir kişi zaten bulunuyor.",
        ERR_LAST_ADMIN: "Hesapta en az bir tane yöneticiniz olmalıdır.",
        ERR_CREATING_COMPANY: "Hasabyňyzy döredip bolmaýar Goldaw goldawy.",
        ERR_INVALID_RECAPTCHA:
          "Howpsuzlygy barlamak säwligi, müşderi goldawyna ýüz tutuň.",
        ERR_PLAN_FEATURE_DISABLED: "Bu özellik mevcut planınızda kullanılamaz. Yükseltme için yöneticinizle iletişime geçin.",
      },
    embeddedSignup: {
      title: "WhatsApp Gömülü Kayıt",
      subtitle: "Numaranızı doğrudan CRM'den kaydedin",
      steps: { configure: "Yapılandır", processing: "İşleniyor", result: "Sonuç" },
      description: "WhatsApp Business numaranızı doğrudan Meta üzerinden kaydetmek için aşağıdaki düğmeye tıklayın.",
      connectionName: "Bağlantı adı",
      connectionNamePlaceholder: "Örn: Ana WhatsApp",
      infoTitle: "Ne olacak:",
      infoItems: { popup: "Bir Meta açılır penceresi açılacak", login: "Facebook Business hesabınızla giriş yapacaksınız", select: "Bir WhatsApp Business hesabı seçecek veya oluşturacaksınız", register: "Numara otomatik olarak CRM'ye kaydedilecek" },
      buttons: { loadingSdk: "SDK yükleniyor...", processing: "İşleniyor...", start: "Meta ile Kaydı Başlat", close: "Kapat", cancel: "İptal" },
      success: { title: "Bağlantı başarıyla oluşturuldu!", name: "Ad", number: "Numara", numberPending: "Yakında görüntülenecek", wabaId: "WABA ID", status: "Durum" },
      errors: { title: "Kayıt hatası", noAppId: "Meta App ID yapılandırılmadı!", noConfigId: "Meta Configuration ID yapılandırılmadı!", noName: "Lütfen bir bağlantı adı girin!", sdkNotLoaded: "Meta SDK düzgün yüklenmedi. Sayfayı yenileyin ve tekrar deneyin.", sdkInitFailed: "Meta SDK başlatılamadı.", sdkLoadFailed: "Meta SDK yüklenemedi. Engelleyicileri devre dışı bırakın ve açılır pencerelere izin verin.", sdkNotAvailable: "Facebook SDK tarayıcıda mevcut değil.", appIdNotConfigured: "Meta App ID yapılandırılmadı! Ayarlar > Meta Entegrasyonları'na gidin.", configIdNotConfigured: "Meta Configuration ID yapılandırılmadı! Ayarlar > Meta Entegrasyonları'na gidin.", timeout: "Zaman aşımı. Meta açılır penceresi tarayıcı tarafından engellenmiş olabilir. Açılır pencerelere izin verin ve tekrar deneyin.", noAuthCode: "Yetkilendirme kodu alınamadı. Uygulama izinlerini kontrol edin.", cancelled: "İşlem kullanıcı tarafından iptal edildi.", signupError: "Kayıt işlemi sırasında hata oluştu.", processingError: "Kayıt işlenirken hata oluştu. Tekrar deneyin.", popupError: "Meta açılır penceresi açılırken hata oluştu. Açılır pencerelere izin verildiğini kontrol edin.", loginCancelled: "Giriş iptal edildi veya yetkilendirilmedi.", metaStatus: "Meta durumu döndürdü:" },
      processing: { title: "Kayıt işleniyor...", description: "Meta ile kimlik bilgilerini değiştiriyoruz ve bağlantınızı ayarlıyoruz." },
      menuItem: "WhatsApp Gömülü Kayıt",
    },
    },
    messagePreview: {
      title: "Önizleme",
      subtitle: "Mesajınızın nasıl görüneceğini görün",
      contact: "Kişi",
      online: "çevrimiçi",
      emptyState: "Önizlenecek mesaj yok",
      typePlaceholder: "Bir mesaj yazın...",
      availableVars: "Kullanılabilir değişkenler:",
      greetingExample: "Günaydın",
      attachedMedia: "Ekli medya",
    },
    reportsExtra: {
      statusDistribution: "Duruma Göre Dağılım",
      ticketsByQueue: "Kuyruğa Göre Biletler",
      ticketsByUser: "Kullanıcıya Göre Biletler",
      noQueue: "Kuyruk yok",
      noUser: "Kullanıcı yok",
      noDataForChart: "Gösterilecek veri yok",
    },
    schedules: {
      title: "Zamanlamalar",
      date: "Tarih",
      time: "Saat",
      event: "Etkinlik",
      allDay: "Tüm Gün",
      week: "Hafta",
      work_week: "İş Haftası",
      day: "Gün",
      month: "Ay",
      previous: "Önceki",
      next: "Sonraki",
      yesterday: "Dün",
      tomorrow: "Yarın",
      today: "Bugün",
      agenda: "Ajanda",
      noEventsInRange: "Bu dönemde etkinlik yok.",
      more: "daha fazla",
      confirmationModal: {
        deleteTitle: "Bu zamanlamayı silmek istediğinizden emin misiniz?",
        deleteMessage: "Bu işlem geri alınamaz.",
      },
      table: {
        contact: "Kişi",
        body: "Mesaj",
        sendAt: "Zamanlama Tarihi",
        sentAt: "Gönderim Tarihi",
        status: "Durum",
        actions: "İşlemler",
      },
      buttons: {
        add: "Yeni Zamanlama",
      },
      toasts: {
        deleted: "Zamanlama başarıyla silindi.",
      },
    },
    chatList: {
      noMessages: "Mesaj yok",
      admin: "Yönetici",
      member: "Üye",
      searchChat: "Sohbet ara...",
      createNewChat: "Yeni sohbet oluştur",
      searchUser: "Kullanıcı ara...",
      noUserFound: "Kullanıcı bulunamadı",
      noUserAvailable: "Kullanılabilir kullanıcı yok",
      cancel: "İptal",
      details: "Detaylar",
      deleteChat: "Sohbeti Sil",
      deleteChatConfirm: "Bu işlem geri alınamaz, onaylıyor musunuz?",
      detailsTitle: "Detaylar",
      edit: "Düzenle",
      delete: "Sil",
      now: "şimdi",
      minutesAgo: "{{count}}dk önce",
      hoursAgo: "{{count}}sa önce",
    },
    chatMessages: {
      deleted: "Bu mesaj silindi",
      deletedAdmin: "Silinen mesaj - yalnızca yöneticiler görebilir",
      reply: "Yanıtla",
      edit: "Düzenle",
      delete: "Sil",
      forward: "İlet",
      editMessage: "Mesajı Düzenle",
      save: "Kaydet",
      cancel: "İptal",
      deleteMessage: "Mesajı Sil",
      deleteMessageConfirm: "Bu mesajı silmek istediğinizden emin misiniz?",
      forwardMessage: "Mesajı İlet",
      selectChat: "Sohbet seçin",
      doubleClickToReply: "Yanıtlamak için çift tıklayın",
      edited: "(düzenlendi)",
      forwarded: "(iletildi)",
      typeMessage: "Bir mesaj yazın...",
      send: "Gönder",
      noMessages: "Mesaj yok",
      loading: "Yükleniyor...",
      replyingTo: "Yanıtlanan",
      clickToGoToOriginal: "Orijinal mesaja gitmek için tıklayın",
    },
    chatPopover: {
      reply: "Yanıtla",
      edit: "Düzenle",
      delete: "Sil",
      forward: "İlet",
      cancel: "İptal",
      confirmDelete: "Silmeyi Onayla",
      confirm: "Onayla",
      deleteMessage: "Bu mesajı silmek istediğinizden emin misiniz?",
      editMessage: "Mesajı Düzenle",
      save: "Kaydet",
      forwardMessage: "Mesajı İlet",
      selectChat: "Sohbet seçin",
      noChats: "Mevcut sohbet yok",
    },
    chatIndex: {
      chats: "Sohbetler",
      groups: "Gruplar",
      new: "Yeni",
      messages: "Mesajlar",
      search: "Ara...",
      noChats: "Sohbet bulunamadı",
      noGroups: "Grup bulunamadı",
      noMessages: "Mesaj yok",
      loading: "Yükleniyor...",
      error: "Veri yüklenirken hata oluştu",
      createGroup: "Grup Oluştur",
      editGroup: "Grubu Düzenle",
      deleteGroup: "Grubu Sil",
      deleteGroupConfirm: "Bu grubu silmek istediğinizden emin misiniz?",
      addGroupPhoto: "Grup Fotoğrafı Ekle",
      changeGroupPhoto: "Grup Fotoğrafını Değiştir",
      groupName: "Grup Adı",
      groupDescription: "Grup Açıklaması",
      save: "Kaydet",
      cancel: "İptal",
      edit: "Düzenle",
      delete: "Sil",
      details: "Detaylar",
      groupDetails: "Grup Detayları",
      title: "Başlık",
      description: "Açıklama",
      editMessage: "Mesajı Düzenle",
      messageLabel: "Mesaj",
      modal: {
        title: "Grup Oluştur",
        editTitle: "Grubu Düzenle",
        save: "Kaydet",
        cancel: "İptal",
        description: "Grup adı ve açıklamasını girin.",
        name: "Grup Adı",
        create: "Oluştur",
        edit: "Düzenle",
      },
    },
    financeiroPage: {
      paid: 'Ödendi',
      overdue: 'Gecikmiş',
      open: 'Açık',
      refunded: 'İade Edildi',
      yes: 'Evet',
      no: 'Hayır',
    },
    adminFinanceiro: {
      paid: 'Ödendi',
      open: 'Açık',
      overdue: 'Gecikmiş',
      refunded: 'İade Edildi',
      refund: 'İade Et',
      refundTitle: 'Faturayı iade et',
      refundMessage: 'Bu faturayı iade etmek istediğinizden emin misiniz?',
      refundSuccess: 'Fatura başarıyla iade edildi.',
    },
    companyFinanceiro: {
      title: 'Planım & Finansal',
      myPlan: 'Planım',
      company: 'Şirket',
      users: 'Kullanıcılar',
      connections: 'Bağlantılar',
      queues: 'Kuyruklar',
      value: 'Değer',
      daysLeft: 'gün kaldı',
      daysOverdue: 'gün gecikmiş',
      expiresOn: 'Bitiş tarihi',
      expiredTitle: 'Abonelik Süresi Doldu!',
      expiredMessage: 'Aboneliğiniz sona erdi. Sistemi kullanmaya devam etmek için yenileyin.',
      availablePlans: 'Mevcut Planlar',
      currentPlan: 'Mevcut Plan',
      changePlan: 'Plan Değiştir',
      earlyPayment: 'Erken Ödeme',
      month: 'ay',
      invoiceHistory: 'Fatura Geçmişi',
      detail: 'Detay',
      dueDate: 'Vade Tarihi',
      status: 'Durum',
      action: 'İşlem',
      pay: 'Öde',
      refund: 'İade Et',
      refundTitle: 'Faturayı iade et',
      refundMessage: 'Bu faturayı iade etmek istediğinizden emin misiniz?',
      refundSuccess: 'Fatura başarıyla iade edildi.',
      features: {
        campaigns: 'Kampanyalar',
        schedules: 'Programlar',
        internalChat: 'Dahili Sohbet',
        integrations: 'Entegrasyonlar',
        flows: 'Akışlar',
        contacts: 'Kişiler',
        realTime: 'Gerçek Zamanlı',
      },
    },
    checkout: {
      almostDone: 'Neredeyse tamam!',
      steps: { data: 'Veriler', customize: 'Özelleştir', review: 'İncele' },
      back: 'GERİ',
      pay: 'ÖDE',
      next: 'İLERİ',
      select: 'SEÇ',
      users: 'Kullanıcılar',
      connection: 'Bağlantı',
      queues: 'Kuyruklar',
      perMonth: '/ay',
      subscriptionSuccess: 'Abonelik başarıyla tamamlandı! Ödeme bekleniyor.',
      total: 'TOPLAM',
      copied: 'Kopyalandı',
      copyQrPix: 'QR PIX kodunu kopyala',
      pixInstructions: 'Tamamlamak için yukarıdaki Pix kodunu tarayarak veya yapıştırarak ödeme yapın ya da aşağıdan Kredi Kartı ile Öde seçeneğini kullanın.',
      payWithCard: 'Kredi Kartı ile Öde',
      payWithMercadoPago: 'MercadoPago ile Öde',
      payWithAsaas: 'Asaas ile Öde',
      licenseRenewed: 'Lisansınız yenilendi, bitiş tarihi:',
      subscriptionSummary: 'Abonelik Özeti',
      planDetails: 'Plan Detayları',
      billing: 'Faturalama',
      monthly: 'Aylık',
      paymentInfo: 'Ödeme Bilgileri',
      email: 'E-posta',
      name: 'İsim',
      cpfCnpj: 'Vergi No',
      fullName: 'Tam ad*',
      fullNameRequired: 'Tam ad gerekli',
      address: 'Adres*',
      addressRequired: 'Adres gerekli',
      city: 'Şehir*',
      cityRequired: 'Şehir gerekli',
      state: 'Eyalet*',
      stateRequired: 'Eyalet gerekli',
      cpfCnpjLabel: 'Vergi No*',
      cpfCnpjRequired: 'Vergi numarası gerekli',
      country: 'Ülke*',
      countryRequired: 'Ülke gerekli',
    },
    flowBuilder: {
      conversationFlows: "Konuşma Akışları",
    },
    flowBuilderTicketModal: {
      addTitle: "Bilet Ekle",
      editTitle: "Bileti Düzenle",
      chooseQueue: "Sektör seçin",
      selectConnection: "Bir bağlantı seçin",
      addQueueError: "Bir sektör seçin",
    },
    flowBuilderConfigPage: {
      basics: 'Temel',
      start: 'Başlangıç',
      startDesc: 'Akışın başlangıç noktası',
      content: 'İçerik',
      contentDesc: 'Metin, görsel, ses veya video gönder',
      textNode: 'Metin',
      textDesc: 'Basit metin mesajı',
      interaction: 'Etkileşim',
      menu: 'Menü',
      menuDesc: 'Sayısal seçenek menüsü',
      interactiveApi: 'Etkileşimli Msg API',
      interactiveApiDesc: 'Düğmeler ve listeler (Não Oficial BLS)',
      input: 'Girdi',
      inputDesc: 'Kullanıcı girdisi topla',
      interval: 'Aralık',
      intervalDesc: 'Yürütmeyi bir süre duraklat',
      logic: 'Mantık',
      randomizer: 'Rastgeleleştirici',
      randomizerDesc: 'Rastgele yol seçimi',
      ifElse: 'Eğer/Değilse (If/Else)',
      ifElseDesc: 'Koşula göre akışı dallandır',
      system: 'Sistem',
      queues: 'Kuyruklar',
      queuesDesc: 'Hizmet kuyruklarını yönet',
      tags: 'Etiketler',
      tagsDesc: 'Kişiye etiket ekle',
      removeTag: 'Etiketi Kaldır',
      removeTagDesc: 'Kişiden etiket kaldır',
      switchFlow: 'Akış Değiştir',
      switchFlowDesc: 'Başka bir akışa yönlendir',
      attendant: 'Temsilci',
      attendantDesc: 'Temsilciye aktar',
      variable: 'Değişken',
      variableDesc: 'Global değişkenleri ayarla',
      aiAgent: 'Yapay Zeka Ajanı',
      aiAgentDesc: 'Yapılandırılmış YZ ajanını kullan',
      httpRequest: 'HTTP İsteği',
      httpRequestDesc: 'Harici HTTP isteği',
      flowEditor: 'Akış Düzenleyici',
    },
    templateMetaModal: {
      title: 'WhatsApp Şablonları',
      searchPlaceholder: 'Şablon Ara',
      templateContent: 'Şablon İçeriği:',
      category: 'Kategori:',
      language: 'Dil:',
      selectedDetails: 'Seçilen Şablon Detayları',
      name: 'Ad:',
      content: 'İçerik:',
      fillValue: 'Değeri doldurun:',
      requiredField: 'Zorunlu alan',
      sendTemplate: 'Şablon Gönder',
      back: 'Geri',
    },
    messagesAPIPage: {
      sendTextMedia: 'Metin / Medya Gönder',
      yourMessageHere: 'Mesajınız burada',
      sendImageUrl: 'URL ile Resim Gönder',
      imageCaption: 'Resim açıklaması',
      sendNoTicket: 'Hızlı Gönderim (Ticketsız)',
      messageNoTicket: 'Ticketsız mesaj',
      batchSend: 'Toplu Gönderim',
      interactiveMessages: 'Etkileşimli Mesajlar',
      chooseOption: 'Bir seçenek seçin:',
      optionalFooter: 'İsteğe bağlı alt bilgi',
      sales: 'Satış',
      support: 'Destek',
      financial: 'Finans',
      sidebar: {
        playground: 'PLAYGROUND',
        history: 'GEÇMİŞ',
        intro: 'GİRİŞ',
        messages: 'MESAJLAR API',
        contacts: 'KİŞİLER',
        tickets: 'TİKETLER / KONUŞMALAR',
        testEndpoint: 'Endpoint Test Et',
        searchEndpoint: 'Endpoint ara...',
        requestCount: 'istek(ler)',
        clearHistory: 'Geçmişi temizle',
        noRequests: 'Henüz istek yok',
        remove: 'Kaldır',
        supportsGroups: 'Grupları destekler',
        docSubtitle: 'Tam dokümantasyon — {{count}} endpoint',
      },
      introItems: {
        auth: 'Kimlik Doğrulama',
        rateLimit: 'Hız Sınırı',
        errorCodes: 'Hata Kodları',
      },
      endpoints: {
        checkNumber: 'Numara Kontrol',
        listConnections: 'Bağlantıları Listele',
        listContacts: 'Kişileri Listele',
        showContact: 'Kişi Bul',
        createContact: 'Kişi Oluştur',
        updateContact: 'Kişi Güncelle',
        deleteContact: 'Kişi Sil',
        listTickets: 'Tiketleri Listele',
        showTicket: 'Tiket Bul',
        createTicket: 'Tiket Oluştur',
        updateTicket: 'Tiket Güncelle',
        deleteTicket: 'Tiket Sil',
        closeAllTickets: 'Tüm Tiketleri Kapat',
        messagesRange: 'Döneme Göre Mesajlar',
      },
      playground: {
        title: 'API Playground',
        desc: 'API endpoint\'lerinizi doğrudan burada test edin. Sunucu temel URL\'sini ve kimlik doğrulama tokenınızı girin.',
        apiUrl: 'API URL',
        token: 'Token',
        copyCurl: 'cURL Kopyala',
        selectEndpoint: 'Önceden tanımlanmış endpoint seçin',
        group: 'Grup',
        send: 'Gönder',
        uploadMedia: 'Medya Yükle',
        formatJson: 'JSON Formatla',
        mediaHint: 'Resim, video, ses veya belge. Gruplar için de çalışır!',
        error: 'Hata',
        response: 'Yanıt',
        yourToken: '<tokenınız>',
      },
      badges: {
        new: 'YENİ',
        required: 'zorunlu',
        optional: 'isteğe bağlı',
      },
      docs: {
        authTitle: 'Kimlik Doğrulama',
        authDesc: 'Tüm endpoint\'ler Bearer token kimlik doğrulaması gerektirir. Token, WhatsApp bağlantısında <b>Bağlantılar → Düzenle → Token</b> menüsünden kaydedilmelidir.',
        rateLimitTitle: 'Hız Sınırı',
        rateLimitDesc: 'WhatsApp engellerinden kaçınmak için gönderimler arasında en az <b>2 saniye</b> aralık önerilir. Toplu gönderimde aralığı kontrol etmek için <code>delay</code> parametresini kullanın.',
        errorCodesTitle: 'Hata Kodları',
        messagesSection: 'Mesajlar API',
        contactsSection: 'Kişiler',
        ticketsSection: 'Tiketler / Konuşmalar',
        parameter: 'Parametre',
        type: 'Tür',
        description: 'Açıklama',
        code: 'Kod',
        meaning: 'Anlam',
        success: 'Başarılı',
        invalidParams: 'Geçersiz veya eksik parametreler',
        invalidToken: 'Geçersiz veya sağlanmamış token',
        notFound: 'Kaynak bulunamadı',
        serverError: 'Sunucu iç hatası',
        sendTextTitle: 'Metin / Medya Gönder',
        sendTextDesc: 'Bireysel kişilere veya <b>gruplara</b> metin veya medya mesajı (resim, video, ses, belge) gönderir. Bir gruba göndermek için <code>"isGroup": true</code> ayarlayın ve <code>number</code> alanına grup JID\'sini girin.',
        paramNumber: 'Kişi numarası veya grup JID',
        paramBody: 'Mesaj metni veya medya açıklaması',
        paramIsGroup: '<code>true</code> ise, <code>@g.us</code> kullanarak gruba gönderir',
        paramMedias: 'Medya dosyası (multipart/form-data)',
        paramUserId: 'Atanacak temsilci ID',
        paramQueueId: 'Yönlendirilecek kuyruk ID',
        paramSendSignature: 'Mesajda temsilci adını dahil et',
        paramCloseTicket: 'Gönderimden sonra tiketi kapat',
        paramNoRegister: 'Tiket oluşturmadan gönder',
        sendImageTitle: 'URL ile Resim Gönder',
        sendImageDesc: 'Herkese açık URL\'den kişiye veya <b>gruba</b> resim gönderir.',
        paramUrl: 'Herkese açık resim URL\'si',
        paramCaption: 'Açıklama',
        paramIsGroupSend: '<code>true</code> ise, gruba gönderir',
        sendNoTicketTitle: 'Hızlı Gönderim (Ticketsız)',
        sendNoTicketDesc: 'Tiket oluşturmadan metin mesajı gönderir. Kişiler ve <b>gruplar</b> için çalışır.',
        bulkTitle: 'Toplu Gönderim (Bulk)',
        bulkDesc: 'Toplu iş başına 100\'e kadar mesaj gönderir. Her mesaj ayrı ayrı <code>isGroup: true</code> içerebilir.',
        buttonsTitle: 'Etkileşimli Mesajlar',
        buttonsDesc: 'Düğmeler, listeler, URL\'ler ve PIX ile etkileşimli mesajlar gönderir. Kişiler ve <b>gruplar</b> için çalışır.',
        checkNumberTitle: 'Numara Kontrol',
        checkNumberDesc: 'Bir numaranın aktif WhatsApp hesabı olup olmadığını kontrol eder.',
        listContactsTitle: 'Kişileri Listele',
        listContactsDesc: 'Şirketin tüm kişilerini döndürür. Sayfalama ve aramayı destekler.',
        paramSearchParam: 'Ad, numara veya e-posta ile arama',
        paramPageNumber: 'Sayfa numarası (varsayılan: 1)',
        showContactTitle: 'ID ile Kişi Bul',
        showContactDesc: 'Belirli bir kişinin verilerini ID ile döndürür.',
        createContactTitle: 'Kişi Oluştur',
        createContactDesc: 'Veritabanında yeni bir kişi oluşturur.',
        paramName: 'Kişi adı',
        paramNumberWhatsApp: 'Ülke+alan kodu ile WhatsApp numarası',
        paramEmail: 'Kişi e-postası',
        paramExtraInfo: 'Özel alanlar',
        updateContactTitle: 'Kişi Güncelle',
        updateContactDesc: 'Mevcut bir kişinin verilerini günceller.',
        deleteContactTitle: 'Kişi Sil',
        deleteContactDesc: 'Bir kişiyi kalıcı olarak siler. <b>Uyarı:</b> Bu işlem geri alınamaz.',
        listTicketsTitle: 'Tiketleri Listele',
        listTicketsDesc: 'Durum, kuyruk ve temsilciye göre filtrelenmiş tiketleri döndürür. Sayfalamayı destekler.',
        paramStatus: '<code>open</code>, <code>pending</code>, <code>closed</code>',
        paramQueueIds: 'Virgülle ayrılmış kuyruk ID\'leri',
        paramSearchTicket: 'Mesaj, kişi veya tikete göre arama',
        paramShowAll: 'Tüm tiketleri listelemek için <code>"true"</code>',
        showTicketTitle: 'ID ile Tiket Bul',
        showTicketDesc: 'Kişi, kuyruk, temsilci ve mesajlar dahil bir tiketin tam detaylarını döndürür.',
        createTicketTitle: 'Tiket Oluştur',
        createTicketDesc: 'Bir kişiye bağlı yeni bir tiket oluşturur. Programatik olarak konuşma başlatmak için kullanışlıdır.',
        paramContactId: 'Bağlı kişi ID',
        paramStatusDefault: '<code>open</code>, <code>pending</code> (varsayılan: open)',
        paramQueueIdTicket: 'Kuyruk ID',
        paramUserIdTicket: 'Sorumlu temsilci ID',
        updateTicketTitle: 'Tiket Güncelle',
        updateTicketDesc: 'Bir tiketin durumunu, kuyruğunu veya temsilcisini günceller. API üzerinden tiket aktarma veya kapatma için kullanışlıdır.',
        paramNewQueueId: 'Yeni kuyruk ID',
        paramNewUserId: 'Yeni temsilci ID',
        deleteTicketTitle: 'Tiket Sil',
        deleteTicketDesc: 'Bir tiketi ve mesajlarını kalıcı olarak siler. <b>Uyarı:</b> Bu işlem geri alınamaz.',
        closeAllTitle: 'Tüm Tiketleri Kapat',
        closeAllDesc: 'Tüm açık tiketleri bir kerede kapatır. Toplu temizlik için idealdir.',
        messagesRangeTitle: 'Döneme Göre Mesajlar',
        messagesRangeDesc: 'Bir tarih aralığındaki mesajları döndürür.',
        paramCompanyId: 'Şirket ID',
        paramStartDate: 'Başlangıç tarihi (YYYY-MM-DD)',
        paramEndDate: 'Bitiş tarihi (YYYY-MM-DD)',
        paramNumberOrJid: 'Numara veya grup JID',
      },
    },
    templateManagerPage: {
      title: 'Şablon Yönetimi',
      connection: 'Bağlantı',
      search: 'Ara...',
      syncTooltip: 'Meta ile Senkronize Et',
      sync: 'Senkronize',
      createTemplate: 'Şablon Oluştur',
      submitApproval: 'Onaya Gönder',
      noOfficialConnection: 'Resmi API bağlantısı bulunamadı. Şablonları yönetmek için resmi bir bağlantı ekleyin.',
      noTemplatesFound: 'Şablon bulunamadı. Senkronize etmek için "Senkronize" veya yeni bir tane oluşturmak için "Şablon Oluştur" tıklayın.',
      tableName: 'Ad',
      tableCategory: 'Kategori',
      tableLanguage: 'Dil',
      tableStatus: 'Durum',
      tableActions: 'İşlemler',
      viewDetails: 'Detayları görüntüle',
      editTemplate: 'Düzenle (şablonu yeniden oluştur)',
      deleteTemplate: 'Şablonu sil',
      marketing: 'Pazarlama',
      utility: 'Hizmetler',
      authentication: 'Kimlik Doğrulama',
    },
    campaignsPhrase: {
      deleted: 'Kampanya başarıyla silindi',
      newCampaign: 'Yeni Kampanya',
      active: 'Aktif',
      inactive: 'Devre Dışı',
      editCampaign: 'Kampanyayı düzenle',
      deleteCampaign: 'Kampanyayı sil',
      noCampaigns: 'Kampanya bulunamadı',
      clickNewCampaign: 'İlk akış kampanyanızı oluşturmak için "Yeni Kampanya" tıklayın',
      name: 'Ad',
      connectionsCol: 'Bağlantılar',
      statusCol: 'Durum',
      nameNotDefined: 'Ad belirlenmedi',
      phrasesConfigured: 'ifade(ler) yapılandırıldı',
    },
    groupManager: { title: "Grup Yöneticisi", groups: "Gruplar", refresh: "Yenile", sync: "Grupları Senkronize Et", syncing: "Senkronize ediliyor...", clearAll: "Tüm grupları temizle", selectConnection: "Bir bağlantı seçin", selectConnectionFirst: "Başlamak için bir bağlantı seçin", clickSyncToLoad: "Grupları yüklemek için Senkronize Et'e tıklayın", connection: "Bağlantı", allConnections: "Tüm bağlantılar", searchGroup: "Grup ara...", noGroupsFound: "Grup bulunamadı", noName: "İsimsiz", connectionLabel: "Bağlantı {{id}}", selectGroup: "Bir grup seçin", selectGroupDesc: "Yönetmek için listeden bir grup seçin", participants: "katılımcı", groupActions: "Grup İşlemleri", changeName: "Adı değiştir", changeNameDesc: "Grup adını değiştir", changeDescription: "Açıklamayı değiştir", changeDescriptionDesc: "Grup açıklamasını düzenle", inviteLink: "Davet bağlantısı", inviteLinkDesc: "Paylaşım bağlantısı oluştur veya kopyala", addParticipants: "Katılımcı ekle", addParticipantsDesc: "Telefon numarasıyla ekle", sendMessage: "Mesaj gönder", sendMessageDesc: "Gruba hayalet etiketli mesaj gönder", settings: "Ayarlar", onlyAdminsSend: "Sadece yöneticiler gönderir", onlyAdminsSendDesc: "Sadece yöneticiler mesaj gönderebilir", restrictEdit: "Düzenlemeyi kısıtla", restrictEditDesc: "Sadece yöneticiler grup bilgilerini düzenleyebilir", participantsCount: "Katılımcılar ({{count}})", creator: "Kurucu", admin: "Yönetici", demoteAdmin: "Yöneticilikten düşür", promoteAdmin: "Yöneticiye yükselt", removeFromGroup: "Gruptan çıkar", dialogChangeName: "Grup adını değiştir", groupName: "Grup adı", cancel: "İptal", save: "Kaydet", dialogChangeDesc: "Grup açıklamasını değiştir", description: "Açıklama", dialogInviteLink: "Davet bağlantısı", close: "Kapat", dialogAddParticipants: "Katılımcı ekle", phoneNumbers: "Telefon numarası(ları)", phoneNumbersPlaceholder: "5521999999999 (birden fazla için virgülle ayırın)", phoneNumbersHelper: "Numarayı ülke+alan koduyla, boşluksuz girin. Örn: 5521999999999", add: "Ekle", dialogSendMessage: "Gruba mesaj gönder", message: "Mesaj", mentionAll: "Tüm katılımcıları etiketle (hayalet etiket)", send: "Gönder", confirmRemoveParticipant: "Bu katılımcıyı çıkarmak istediğinizden emin misiniz?", toasts: { loadError: "Gruplar yüklenirken hata", selectConnectionFirst: "Önce bir bağlantı seçin", syncSuccess: "{{count}} grup senkronize edildi!", metadataError: "Grup verileri yüklenirken hata", nameUpdated: "Grup adı güncellendi!", nameError: "Grup adı güncellenirken hata", descUpdated: "Açıklama güncellendi!", descError: "Açıklama güncellenirken hata", inviteLinkError: "Davet bağlantısı oluşturulurken hata", linkCopied: "Bağlantı kopyalandı!", participantAdded: "Katılımcı(lar) eklendi!", participantAddError: "Katılımcı eklenirken hata", messageSent: "Mesaj gönderildi!", messageError: "Mesaj gönderilirken hata", settingUpdated: "Ayar güncellendi!", settingError: "Ayar güncellenirken hata", participantRemoved: "Katılımcı çıkarıldı!", removeError: "Katılımcı çıkarılırken hata", promoted: "Katılımcı yöneticiye yükseltildi!", promoteError: "Katılımcı yükseltilirken hata", demoted: "Yönetici düşürüldü!", demoteError: "Katılımcı düşürülürken hata" } },
    flowDefaultPage: {
      title: "Varsayılan Akış",
      welcomeFlow: "Karşılama Akışı",
      welcomeFlowDesc: "Bu akış yalnızca yeni kişiler, kişi listenizde olmayan ve mesaj gönderen kişiler için tetiklenir",
      defaultResponseFlow: "Varsayılan Yanıt Akışı",
      defaultResponseFlowDesc: "Varsayılan Yanıt, bir anahtar kelimeden farklı herhangi bir karakter ile gönderilir. DİKKAT! Destek talebi zaten kapalıysa tetiklenir.",
      defaultResponseFlowDescLong: "Varsayılan Yanıt, bir anahtar kelimeden farklı herhangi bir karakter ile gönderilir. DİKKAT! Destek talebi zaten kapalıysa ve kapatılmasından 6 saat geçtiyse tetiklenir.",
      disabled: "Devre Dışı",
      chooseFlow: "Bir akış seçin",
      disconnect: "Bağlantıyı kes",
      save: "Kaydet",
      deleteConfirm: "Bu akışı silmek istediğinizden emin misiniz? Tüm ilgili entegrasyonlar kaybolacaktır.",
    },
    flowBuilderStart: { title: "Akış başlangıcı", description: "Bu blok akışınızın başlangıcını işaret eder!" },
    flowBuilderConditionCompareNode: { title: "Eğer / Değilse", contains: "içerir", notContains: "içermez", containsAny: "herhangi birini içerir", startsWith: "ile başlar", endsWith: "ile biter", isEmpty: "boş", isNotEmpty: "boş değil", regex: "regex", field: "alan", value: "değer", and: "VE", or: "VEYA", true: "Doğru", false: "Yanlış" },
    flowBuilderHttpRequest: { title: "HTTP İsteği", preconfiguredWebhooks: "Önceden Yapılandırılmış Webhooklar", selectPreset: "Ön ayar seç", choosePreset: "Hazır bir yapılandırma seçin...", system: "SİSTEM", remove: "Kaldır", usingPreset: "Ön ayar kullanılıyor:", urlFromPreset: "URL (ön ayardan)", urlPlaceholder: "https://api.ornek.com/webhook", editPresetUrl: "Gerekirse ön ayar temel URL'sini düzenleyebilirsiniz", method: "Yöntem", testRequest: "İsteği Test Et", apiResponse: "API Yanıtı:", viewFullResponse: "Tam yanıtı görüntüle", hideAdvanced: "Gelişmişi gizle", showAdvanced: "Gelişmişi göster", advancedWarning: "Gelişmiş ayarlar ön ayar ayarlarını geçersiz kılabilir", timeoutMs: "Zaman aşımı (ms)", queryParams: "Sorgu Parametreleri", key: "Anahtar", addParam: "Parametre Ekle", headersJson: "Başlıklar (JSON)", requestBody: "İstek gövdesi (JSON)", editRequestBody: "İstek gövdesini düzenle", close: "Kapat", hideMapVars: "Yanıt Değişkenlerini Gizle", showMapVars: "Yanıt Değişkenlerini Eşle", mapResponseData: "Yanıt verilerini değişkenlere eşle", path: "Yol", pathPlaceholder: "ör: data.user.id", variableName: "Değişken adı", variablePlaceholder: "ör: userId", addVariable: "Değişken ekle", tips: "Faydalı ipuçları:", tipAutoSave: "Tam API yanıtı otomatik olarak global değişkene kaydedilir", tipVarUsage: "Değişken değerlerini dahil etmek için URL ve istek gövdesinde ${degiskenAdi} kullanabilirsiniz.", requestError: "İstek hatası", configSaved: "Yapılandırma kaydedildi!", fullApiResponse: "Tam API yanıtı", presetError: "Ön ayar yapılandırması uygulanırken hata", value: "Değer" },
    flowBuilderInteractiveNode: { title: "Etkileşimli API Msg", buttons: "Düğmeler", maxButtons: "maks. 3", messageBody: "Mesaj gövdesi...", select: "Seç", button: "Düğme", item: "Öğe" },
    flowBuilderRemoveTag: { addTitle: "Akıştan etiket kaldır", editTitle: "Etiket kaldırmayı düzenle", addRemoval: "Kaldırma Ekle", edit: "Düzenle", selectTagToRemove: "Kaldırılacak bir etiket seçin", noTagSelected: "Etiket seçilmedi", chooseTag: "Kişiden kaldırılacak bir etiket seçin", actionDescription: "Bu işlem, akış çalıştırıldığında seçilen etiketi kişiden kaldıracaktır", selectTagError: "Kaldırılacak bir etiket seçin", title: "Etiketi Kaldır", tagNotSelected: "Etiket seçilmedi", removesTagFromContact: "Etiketi kişiden kaldırır" },
    flowBuilderVariable: { title: "Global Değişken", variableName: "Değişken adı", value: "Değer", helperText: "Statik değerler veya ${baskaDeğişken} gibi referanslar kullanabilirsiniz", saved: "Kaydedildi!", saveVariable: "Değişkeni kaydet", variableSavedSuccess: "Değişken başarıyla kaydedildi!" },
    flowBuilderAiAgent: { title: "Yapay Zeka Ajanı", selectAgent: "Bir ajan seçin" },
    flowBuilderAttendant: { title: "Temsilci" },
    flowBuilderAudioNode: { title: "Ses", recordedLive: "Canlı kaydedildi", audioSent: "Ses gönderildi" },
    flowBuilderVideoNode: { title: "Video" },
    flowBuilderMessageNode: { title: "Mesaj" },
    flowBuilderConditionNode: { title: "Koşul" },
    flowBuilderImageNode: { title: "Görsel" },
    flowBuilderInputNode: { title: "Girdi", question: "Soru:", questionNotDefined: "Soru tanımlanmadı", variableToStore: "Yanıtı saklamak için değişken:", variableNotDefined: "Değişken tanımlanmadı", usingVariables: "Değişkenler kullanılıyor:", alwaysAsk: "Her zaman sor (değişken zaten varsa bile)" },
    flowBuilderMenuNode: { title: "Sayısal Menü" },
    flowBuilderIntervalNode: { title: "Aralık" },
    flowBuilderRandomizerNode: { title: "Rastgeleleştirici" },
    flowBuilderSingleBlockNode: { title: "İçerik" },
    flowBuilderSwitchFlowNode: { title: "Akış Değiştir" },
    flowBuilderTypebotNode: { title: "TypeBot" },
    flowBuilderQuestionNode: { title: "Soru" },
    flowBuilderTagNode: { title: "Etiket" },
    flowBuilderTicketNode: { title: "Kuyruk" },
    flowBuilderAiAgentModal: { addTitle: "Yapay Zeka Ajanı Ekle", editTitle: "Yapay Zeka Ajanını Düzenle", add: "Ekle", save: "Kaydet", cancel: "İptal", selectAgent: "Bir Yapay Zeka Ajanı Seçin", agentLabel: "Yapay Zeka Ajanı", selectPlaceholder: "Seçin...", subtitle: "Bu akışta kullanmak için aktif bir ajan seçin", noAgentsFound: "Aktif ajan bulunamadı. \"Yapay Zeka Ajanları\" sayfasından bir ajan oluşturun.", defaultAgentName: "Yapay Zeka Ajanı" },
    flowBuilderInput: {
      addTitle: "Akışa girdi ekle",
      title: "Akışa girdi ekle", editTitle: "Akış girdisini düzenle",
      add: "Ekle", saveChanges: "Değişiklikleri kaydet",
      question: "Soru", questionTooltip: "Kullanıcıya gönderilecek soru.",
      questionLabel: "Soruyu yazın", typeQuestion: "Soruyu yazın",
      questionPlaceholder: "Ör: Merhaba {{firstName}}, kaç yaşındasınız?",
      flowVariables: "Akış değişkenleri (eklemek için tıklayın):",
      variableName: "Değişken adı", variableNameTooltip: "Yanıtın saklanacağı değişkenin adı.",
      variableTooltip: "Yanıtın saklanacağı değişkenin adı.",
      variableNameLabel: "Değişken adı", variableNamePlaceholder: "Ör: musteri_yasi",
      variablePlaceholder: "Ör: musteri_yasi",
      variableNameHelper: "Kullanıcının yanıtı bu değişkende saklanacak",
      variableHelper: "Kullanıcının yanıtı bu değişkende saklanacak",
      howItWorks: "Nasıl çalışır",
      howItWorksDescription: "Bu düğüm soruyu kullanıcıya gönderecek ve yanıt bekleyecektir.",
      howItWorksDesc: "Bu düğüm soruyu kullanıcıya gönderecek ve yanıt bekleyecektir.",
      examples: { name: "Müşteri adı", email: "Müşteri e-postası", phone: "Müşteri telefonu", city: "Müşteri şehri" },
      exampleVars: { nome: "Müşteri adı", email: "Müşteri e-postası", telefone: "Müşteri telefonu", cidade: "Müşteri şehri" },
    },
    flowBuilderRandomizerModal: { addTitle: "Akışa rastgeleleştirici ekle", editTitle: "Rastgeleleştiriciyi düzenle", addIntervalError: "Yüzde 0'dan büyük olmalıdır", maxTimeError: "Yüzde 120'den büyük olamaz" },
    flowBuilderMenu: { addTitle: "Akışa menü ekle", editTitle: "Akış menüsünü düzenle", add: "Ekle", save: "Kaydet", menuMessage: "Menü mesajı", addOption: "Seçenek ekle", digit: "Rakam", typeOption: "Seçeneği yazın" },
    flowBuilderInterval: { addTitle: "Akışa aralık ekle", editTitle: "Aralığı düzenle", add: "Ekle", edit: "Düzenle", timeInSeconds: "Saniye cinsinden süre", addIntervalError: "Aralık 0'dan büyük olmalıdır", maxTimeError: "Aralık 120'den büyük olamaz" },
    flowBuilderValidation: { tooShort: "Çok kısa!", tooLong: "Çok uzun!", enterName: "Bir ad girin!", enterMessage: "Bir mesaj girin!", required: "Zorunlu" },
    audioTranscription: { transcription: "Transkripsiyon:", transcribing: "Yazıya dökülüyor...", transcribe: "Yazıya Dök", failed: "Metin dönüştürme başarısız oldu" },
    flowBuilderPageExtra: {
      title: "Konuşma Akışları",
      newFlow: "Yeni Akış",
      importZip: "İçe Aktar (.zip)",
      noFlowFound: "Akış bulunamadı",
      noFlowCreated: "Henüz akış oluşturulmadı",
      tryOtherSearch: "Başka arama terimleri kullanmayı deneyin",
      createFirstFlowDesc: "Desteği otomatikleştirmek için ilk konuşma akışınızı oluşturun",
      createFirstFlow: "İlk Akışı Oluştur",
    },
    floupPage: {
      title: "Follow UP - Akış Şablonları",
      filterActive: "Aktif",
      filterError: "Hatalı",
      filterPaused: "Duraklatıldı",
      filterAll: "Tümü",
      newTemplate: "Yeni Şablon",
      editTemplate: "Şablonu Düzenle",
      basicInfo: "Temel Bilgiler",
      templateName: "Şablon Adı",
      templateType: "Şablon Türü",
      description: "Açıklama",
      triggerCondition: "Tetikleme Koşulu",
      triggerConditionDesc: "Bu Follow UP'ın ne zaman tetikleneceğini tanımlayın. Tetiklendikten sonra, durdurma koşulları karşılanana kadar tüm adımlar sırayla çalışır.",
      condition: "Koşul",
      systemQueue: "Sistem kuyruğu",
      systemTag: "Sistem etiketi",
      firstClientInteraction: "İlk müşteri etkileşimi",
      firstAttendantInteraction: "İlk temsilci etkileşimi",
      queue: "Kuyruk",
      selectQueue: "Kuyruk seçin",
      tag: "Etiket",
      selectTag: "Etiket seçin",
      conditionDescription: "Koşul açıklaması",
      conditionPlaceholder: "Örn: Müşteri ilk mesajı gönderdi",
      flowStopControls: "Akış Durdurma Kontrolleri",
      stopAnyMessage: "1. Kişi herhangi bir mesajla yanıt verirse",
      stopKeyword: "2. Kişi bir Anahtar Kelime ile yanıt verirse",
      keyword: "Anahtar kelime",
      keywordPlaceholder: "Örn: DUR, İPTAL, ÇIKIŞ",
      stopTicketClosed: "3. Destek Talebi Kapatılırsa",
      flowSteps: "Akış Adımları",
      addStep: "Adım Ekle",
      cancel: "İptal",
      saveTemplate: "Şablonu Kaydet",
      confirmDeleteTitle: "Silmeyi Onayla",
      confirmDeleteMessage: "Bu Follow UP'ı silmek istediğinizden emin misiniz",
      confirmDeleteWarning: "Bu işlem geri alınamaz ve ilişkili tüm medya kalıcı olarak silinecektir.",
      delete: "Sil",
      duplicate: "Çoğalt",
      edit: "Düzenle",
      steps: "adım",
      active: "Aktif",
      inactive: "Devre Dışı",
      customized: "Özelleştirilmiş",
      client: "Müşteri",
      lead: "Aday",
      basicInfoDesc: "Follow Up'ınızın adını ve türünü yapılandırın. Tür, ilk mesaj şablonunu belirler.",
      stepsDesc: "Follow Up akış adımlarını yapılandırın. Yeniden sıralamak için okları kullanın.",
      stopControlsDesc: "Follow Up'ın ne zaman otomatik olarak durması gerektiğini ayarlayın.",
      subtitle: "Follow Up şablonlarınızı yönetin",
      noFlowsYet: "Henüz Follow UP oluşturulmadı",
      step: "Adım",
      emptyMessage: "Boş mesaj",
      message: "Mesaj",
      variablesHint: "Değişkenler: {" + "{ad}}, {" + "{protokol}}, {" + "{kuyruk}}",
      interval: "Aralık",
      unit: "Birim",
      minutesLabel: "Dakika",
      hoursLabel: "Saat",
      daysLabel: "Gün",
      weeksLabel: "Hafta",
      monthsLabel: "Ay",
      attachment: "Ek/Medya",
      pasteUrl: "URL'yi yapıştırın...",
      choose: "Seç",
      uploadError: "Yükleme hatası.",
      removeStep: "Adımı Kaldır",
      conversationPreview: "Sohbet Önizleme",
      addStepsForPreview: "Önizlemeyi görmek için adım ekleyin",
      afterLabel: "Sonra",
      fileLabel: "Dosya",
      previous: "Önceki",
      next: "Sonraki",
      queueLabel: "Kuyruk",
      tagLabel: "Etiket",
      interactionLabel: "Etkileşim",
      stepsCount: "adım",
    },
    templateManagerPageExtra: {
      createNewTemplate: "Yeni Şablon Oluştur",
      templateNameLabel: "Şablon Adı",
    },
    templateManagerForm: {
      rejected: "Meta tarafından REDDEDİLDİ",
      syncComplete: "Senkronizasyon tamamlandı",
      statusChanged: "durum değişikliği ile",
      syncNoChanges: "Şablonlar senkronize edildi - durum değişikliği yok",
      tokenExpired: "⚠️ Resmi API token'ı süresi dolmuş veya geçersiz! Meta erişim token'ını bağlantı ayarlarından güncelleyin.",
      nameBodyRequired: "Ad ve mesaj gövdesi gereklidir",
      nameValidation: "Şablon adı yalnızca küçük harf, rakam ve alt çizgi (_) içermelidir",
      sentForApproval: "Şablon Meta onayına gönderildi!",
      deleteSuccess: "Şablon başarıyla silindi!",
      confirmDeleteMessage: "Bu işlem şablonu Meta'da ve yerel olarak silecektir. Devam etmek istiyor musunuz?",
      templateDetails: "Şablon Detayları",
      name: "Ad",
      language: "Dil",
      status: "Durum",
      category: "Kategori",
      components: "Bileşenler",
      close: "Kapat",
      nameHelper: "Yalnızca küçük harf, rakam ve _",
      headerOptional: "Başlık (isteğe bağlı)",
      headerHelper: "Şablonun üstünde görüntülenen metin",
      messageBody: "Mesaj Gövdesi",
      messageBodyHelper: "Değişkenler için {{1}}, {{2}}, vb. kullanın. Örn: Merhaba {{1}}, siparişiniz {{2}} hazır!",
      footerOptional: "Alt bilgi (isteğe bağlı)",
      footerHelper: "Şablonun sonundaki küçük metin",
      buttonsOptional: "Butonlar (isteğe bağlı - maks 3)",
      quickReply: "Hızlı Yanıt",
      phone: "Telefon",
      text: "Metin",
      preview: "Önizleme",
      button: "Buton",
      cancel: "İptal",
    },
    whatsappModalRel: {
      form: {
        resolveAndTriggerIntegration: "Çöz ve Entegrasyonu Tetikle",
        reportFilename: "Bilet_Raporu_",
        elementNotFoundForExport: "Dışa aktarma için öğe bulunamadı",
      },
    },
    announcementsPopover: {
      title: "Duyurular",
      dontShowAgain: "Tekrar gösterme",
      dismiss: "Kapat",
      dismissAll: "Tümünü kapat",
      close: "Kapat",
      backToList: "Listeye dön",
      dismissedToast: "Bu duyuru artık gösterilmeyecek. Yalnızca yenilikler olduğunda tekrar görünecektir.",
      priority: {
        high: "Yüksek",
        medium: "Orta",
        low: "Düşük",
      },
      priorityLabel: "Öncelik",
    },
    ticketsManagerExtra: {
      viewAll: "Tümü",
      ascending: "Artan",
      descending: "Azalan",
      searchOnMessages: "Mesaj içeriklerinde de arama yapmak için işaretleyin (daha yavaş)",
    },
    announcementsPage: {
      noPermission: "Bu şirketin bu sayfaya erişim izni yok! Yönlendiriliyorsunuz.",
      priorityHigh: "Yüksek",
      priorityMedium: "Orta",
      priorityLow: "Düşük",
    },
    pairingCodeModalExtra: {
      phoneRequired: "Telefon numarasını girin.",
      phoneTooShort: "Numara çok kısa. Ülke kodu + alan kodu ekleyin.",
      phoneTooLong: "Numara çok uzun.",
      phoneBrazil: "Brezilya numaraları için 55 + alan kodu + numara kullanın.",
      connectedSuccess: "✅ WhatsApp başarıyla bağlandı!",
      pairingFailed: "⚠️ Eşleştirme başarısız. Tekrar deneyin.",
      instructionText: "WhatsApp numarasını girin",
      instructionHighlight: "ülke kodu + alan kodu",
      exampleNumber: "5511999998888",
      digitsHelper: "rakam — ülke kodu + alan kodu + numara",
      whatsappInstructions: "WhatsApp'ınızda şuraya gidin:",
      whatsappSteps: "Ayarlar → Bağlı Cihazlar → Cihaz Bağla",
      tapLink: "Dokunun",
      linkWithPhone: "Telefon numarasıyla bağla",
      enterCodeExact: "ve kodu tam olarak gösterildiği gibi girin (boşluk olmadan):",
      stepCodeGenerated: "Kod oluşturuldu",
      stepWaitingPairing: "Eşleştirme bekleniyor",
      stepSyncing: "Senkronize ediliyor",
      stepConnected: "Bağlandı",
    },
    newTicketOficialModal: {
      title: "Yeni Konuşma - Resmi API",
      selectQueue: "Bir kuyruk seçin",
      selectOfficialConnection: "Resmi bir Bağlantı seçin",
      selectQueuePlaceholder: "Bir kuyruk seçin",
      selectConnectionPlaceholder: "Resmi bir Bağlantı seçin",
      officialApiLabel: "Resmi API",
      createAndSendTemplate: "Oluştur ve Şablon Gönder",
      templateSentSuccess: "Şablon başarıyla gönderildi!",
      selectQueueError: "Bir kuyruk seçin",
      selectConnectionError: "Resmi bir bağlantı seçin",
    },
    interactiveMessageModalExtra: {
      sendInteractiveMessage: "Etkileşimli Mesaj Gönder",
      modelsCount: "Modeller ({{count}})",
      saveCurrentConfig: "Mevcut yapılandırmayı bu tür için yeniden kullanılabilir bir şablon olarak kaydedin",
      saveButton: "Kaydet",
      templateLoaded: "\"{{name}}\" şablonu yüklendi",
      buttonsInfo: "ℹ️ 3'e kadar tıklanabilir düğme gönderin. Müşteri hızlı yanıt vermek için bir düğmeye dokunabilir.",
      messageText: "Mesaj metni *",
      footer: "Alt bilgi (isteğe bağlı)",
      buttonsMax: "Düğmeler (maks. 3)",
      add: "Ekle",
      optionPlaceholder: "Seçenek {{n}}",
      listInfo: "ℹ️ 10'a kadar seçenekli bir liste gönderin. Müşteri seçmek için bir menü açar.",
      buttonText: "Düğme metni",
      sectionTitle: "Bölüm başlığı",
      titleLabel: "Başlık",
      descriptionLabel: "Açıklama",
      addOption: "Seçenek ekle",
      offerInfo: "🏷️ Başlık, fiyat ve açıklamalı bir teklif gönderin.",
      offerTitle: "Teklif başlığı",
      offerBody: "Açıklama / Mesaj metni *",
      offerPrice: "Fiyat (ör: 99,90 TL)",
      offerDetails: "Ek detaylar",
      pixInfo: "💰 Müşteriye formatlanmış PIX verileri gönderin.",
      pixKey: "PIX Anahtarı *",
      pixKeyPlaceholder: "CPF, CNPJ, e-posta, telefon veya rastgele anahtar",
      pixBeneficiary: "Alıcı adı",
      pixCity: "Şehir",
      pixAmount: "Tutar",
      urlInfo: "🔗 Özel metinli tıklanabilir bir bağlantı gönderin.",
      linkText: "Bağlantı metni",
      linkPlaceholder: "Buraya tıklayın",
      urlLabel: "URL *",
      callInfo: "📞 Arama için telefon numaralı bir mesaj gönderin.",
      callButtonText: "Düğme metni",
      callPlaceholder: "Şimdi ara",
      callPhoneLabel: "Telefon numarası *",
      locationInfo: "📍 Müşteriye bir konum gönderin.",
      locationMessageText: "Mesaj metni",
      locationName: "Konum adı",
      locationAddress: "Adres",
      latitudeLabel: "Enlem *",
      longitudeLabel: "Boylam *",
      carouselInfo: "🎠 Birden fazla kartı karusel olarak gönderin.",
      cardLabel: "Kart {{n}}",
      cardTitle: "Başlık",
      cardDescription: "Açıklama",
      addCard: "Kart ekle",
      catalogInfo: "🛍️ Katalogdaki ürünleri kart olarak gönderin.",
      productLabel: "Ürün {{n}}",
      productName: "Ürün adı",
      productDescription: "Açıklama / Fiyat",
      addProduct: "Ürün ekle",
      pollInfo: "📊 Müşterinin oy kullanması için bir anket oluşturun.",
      pollOfficialNote: "(Resmi API'de formatlanmış metin olarak gönderilecek)",
      pollQuestion: "Anket sorusu *",
      pollOptionsLabel: "Seçenekler (min. 2, maks. 12)",
      billingInfo: "🧾 Ödeme detayları ve \"İncele ve öde\" düğmesiyle bir fatura gönderin.",
      billingNumber: "Fatura numarası",
      billingDescription: "Fatura açıklaması *",
      billingQuantity: "Miktar",
      billingTotalAmount: "Toplam tutar *",
      billingCustomMessage: "Özel mesaj",
      billingAttachPdf: "📄 PDF / Fatura Ekle (isteğe bağlı)",
      billingSelectPdf: "PDF Seç",
      billingPaymentButton: "Ödeme düğmesi",
      billingButtonText: "Düğme metni",
      billingPaymentUrl: "Ödeme URL'si (isteğe bağlı)",
      billingPaymentUrlHelper: "Doldurulursa, düğme tıklanabilir bir bağlantı olacak",
      billingNumberPreview: "FATURA NUMARASI",
      billingQuantityPreview: "Miktar",
      billingTotal: "Toplam",
      billingDefaultBody: "Mesaj metni...",
      billingDefaultDescription: "Fatura açıklaması...",
      billingDefaultButton: "İncele ve öde",
    },
    whatsAppModalExtra: {
      saturday: "Cumartesi",
      sunday: "Pazar",
      saveSchedulesHint: "Değişiklikleri kaydetmek için kaydet'e tıklayın",
    },
    tagsKanbanContainer: {
      label: "Kanban Aşaması",
      selectStep: "Bir aşama seçin",
      selectKanbanStep: "Bir Kanban Aşaması Seçin",
      none: "Hiçbiri",
      loadingSteps: "Aşamalar yükleniyor...",
    },
    pendingTicketOverlay: {
      blockedTitle: "Konuşma Engellendi",
      blockedSubtitle: "Bu bilet kabul bekliyor. Müşterinin mesajlarını görüntülemek ve yanıtlamak için konuşmayı kabul edin.",
      statusWaiting: "Durum: Bekliyor",
      contact: "Kişi",
      ticketId: "Bilet #{{id}}",
      accepting: "Kabul ediliyor...",
      acceptConversation: "Konuşmayı Kabul Et",
      warningText: "🚫 Bileti kabul etmeden mesajları görüntüleyemezsiniz",
    },
    documentModalExtra: {
      viewDocument: "Belgeyi Görüntüle",
      open: "Aç",
      download: "İndir",
      emailOutlook: "Outlook E-postası",
      keynotePresentation: "Keynote Sunumu",
      numbersSpreadsheet: "Numbers Tablosu",
      pagesDocument: "Pages Belgesi",
      executable: "Çalıştırılabilir",
      retFile: "RET Dosyası",
      document: "Belge",
    },
    statusFilterExtra: {
      groups: "Gruplar",
    },
    telegram: {
      botTokenTitle: "🤖 Telegram Bot Tokeni",
      botTokenHelp: "Telegram'da @BotFather üzerinden bir bot oluşturun ve tokeni buraya yapıştırın. Webhook kaydetme sırasında otomatik olarak yapılandırılacaktır.",
      botTokenLabel: "Bot Token",
      webhookUrl: "Webhook URL",
      connectBot: "Botu Bağla",
      chip: "TELEGRAM",
    },
    locationPreview: {
      openInMaps: "Google Haritalar'da Aç",
    },
    kanbanCard: {
      assignValue: "Değer Ata",
      value: "Değer: {{value}}",
      remove: "Kaldır",
      viewTicket: "Bileti Görüntüle",
      editValue: "Düzenle",
      assignValueTitle: "Fırsat Değeri Ata",
      editValueTitle: "Fırsat Değerini Düzenle",
      valueLabel: "Değer",
      cancel: "İptal",
      save: "Kaydet",
      noName: "İsimsiz",
      noMessages: "Mesaj yok",
      pending: "Beklemede",
      addValue: "Değer ekle",
      viewChat: "Sohbeti görüntüle",
      slaOnTime: "Zamanında",
      slaWarning: "Dikkat",
      slaOverdue: "Gecikmiş",
    },
    kanbanColumn: {
      searchPlaceholder: "İsim, numara ile ara...",
      noResults: "Sonuç yok",
      noTickets: "Bilet yok",
      slaOnTime: "Zamanında",
      slaWarning: "Dikkat",
      slaOverdue: "Gecikmiş",
      totalValue: "Toplam değer",
    },
    kanbanChat: {
      statusOpen: "Açık",
      statusPending: "Beklemede",
      statusClosed: "Kapalı",
      contact: "Kişi",
      noQueue: "Kuyruk yok",
      noMessages: "Henüz mesaj yok",
      inputPlaceholder: "Bir mesaj yazın...",
    },
    n8nNodes: {
      webhook: "n8n Webhook",
      wait: "n8n Bekle",
      query: "n8n Sorgu",
      sendMessage: "n8n Mesaj",
      configureUrl: "Webhook URL'sini Yapılandır",
      configureQuery: "Sorguyu Yapılandır",
      configureWebhook: "Webhook'u Yapılandır",
      waitingReturn: "n8n dönüşü bekleniyor",
      receiveAndSend: "Mesajı al ve gönder",
      sendsTicketData: "Bilet verilerini gönderir",
      sendsContactData: "Kişi verilerini gönderir",
      queryN8n: "n8n Sorgu",
      resultIn: "Sonuç",
      sendsResponseToClient: "Müşteriye yanıt gönderir",
      waitsN8nResponse: "n8n yanıtını bekliyor",
      field: "Alan",
      variable: "Değişken",
      saveIn: "Kaydet",
      error: "hata",
    },
    n8nModal: {
      editWebhook: "n8n Webhook'u Düzenle",
      editWait: "n8n Beklemeyi Düzenle",
      editQuery: "n8n Sorguyu Düzenle",
      editSendMessage: "n8n Mesaj Göndermeyi Düzenle",
      addWebhook: "n8n - Webhook",
      addWait: "n8n - Dönüşü Bekle",
      addQuery: "n8n - Sorgu",
      addSendMessage: "n8n - Mesaj Gönder",
      nodeType: "n8n Düğüm Türü",
      webhookOption: "Webhook - Veri gönder",
      waitOption: "Bekleme - Callback'e kadar duraklat",
      queryOption: "Sorgu - Veri getir ve döndür",
      sendMessageOption: "Mesaj Gönder - n8n'den metin al ve gönder",
      webhookInfo: "n8n webhook'una veri gönderir. Akış gönderdikten hemen sonra devam eder.",
      waitInfo: "n8n'e veri gönderir ve callback alınana kadar akışı DURAKLATIR.",
      queryInfo: "n8n'e senkron sorgu yapar ve yanıtı bir değişkende saklar.",
      sendMessageInfo: "Bilet/kişi verilerini n8n'e gönderir, işlenmiş metni bekler ve müşteriye otomatik gönderir.",
      webhookUrlLabel: "n8n Webhook URL'si",
      webhookUrlPlaceholder: "https://n8n-adresiniz.com/webhook/...",
      authTokenLabel: "Kimlik Doğrulama Jetonu (isteğe bağlı)",
      authTokenPlaceholder: "n8n ile kimlik doğrulama jetonu",
      dataToSend: "Gönderilecek veriler",
      ticketData: "Bilet Verileri",
      contactData: "Kişi Verileri",
      lastMessage: "Son alınan mesaj",
      customPayload: "Özel yük (isteğe bağlı JSON)",
      waitConfig: "Bekleme Yapılandırması",
      timeoutMinutes: "Zaman Aşımı (dakika)",
      timeoutHelper: "Maksimum bekleme süresi.",
      saveResponseVar: "Yanıtı kaydetmek için değişken",
      saveResponseHelper: "n8n yanıtı bu değişkende saklanacak.",
      waitingMessage: "Beklerken mesaj (isteğe bağlı)",
      queryConfig: "Sorgu Yapılandırması",
      queryNameLabel: "Sorgu Adı",
      queryPayloadLabel: "Sorgu yükü (JSON)",
      queryPayloadHelper: "Akış değişkenlerini eklemek için {{değişken}} kullanın",
      queryResultVar: "Sonucu kaydetmek için değişken",
      queryResultHelper: "Sorgu sonucu bu değişkende saklanacak",
      sendResultAsMessage: "Sonucu müşteriye mesaj olarak gönder",
      messageTemplate: "Mesaj şablonu",
      messageTemplateHelper: "Sonucu interpolasyon için {{değişken}} kullanın",
      sendConfig: "Gönderme Yapılandırması",
      responseFieldLabel: "Mesajı içeren yanıt alanı",
      responseFieldHelper: "Metni içeren n8n JSON yanıt alanı.",
      timeoutSeconds: "Zaman Aşımı (saniye)",
      timeoutSecondsHelper: "n8n yanıtı için maksimum bekleme süresi",
      saveResponseVarOptional: "Yanıtı kaydetmek için değişken (isteğe bağlı)",
      saveResponseVarHelper: "Döndürülen metni daha sonra kullanmak için bir değişkende saklar",
      fallbackMessage: "Yedek mesaj (n8n başarısız olursa)",
      fallbackHelper: "n8n yanıt vermezse veya hata oluşursa müşteriye gönderilir",
      flowWarning: "Bilet ve kişi verileri n8n'e gönderilir → n8n işler ve metni döndürür → metin otomatik olarak WhatsApp üzerinden müşteriye gönderilir.",
      webhookRequired: "Webhook URL'si zorunludur",
      cancel: "İptal",
      save: "Kaydet",
      add: "Ekle",
    },
    n8nMonitor: {
      title: "n8n İzleme",
      total: "Toplam",
      success: "Başarılı",
      errors: "Hatalar",
      pending: "Bekleyen",
      avgDuration: "Ort. Süre",
      successRate: "Başarı Oranı",
      startDate: "Başlangıç Tarihi",
      endDate: "Bitiş Tarihi",
      status: "Durum",
      nodeType: "Düğüm Türü",
      all: "Tümü",
      webhook: "Webhook",
      waitReturn: "Dönüşü Bekle",
      query: "Sorgu",
      sendMessage: "Mesaj Gönder",
      id: "ID",
      dateTime: "Tarih/Saat",
      type: "Tür",
      ticket: "Bilet",
      contact: "Kişi",
      duration: "Süre",
      details: "Detaylar",
      noLogs: "Kayıt bulunamadı",
      executionDetail: "Yürütme Detayları",
      nodeTypeLabel: "Düğüm Türü",
      webhookUrl: "Webhook URL'si",
      errorMessage: "Hata Mesajı",
      payloadSent: "Gönderilen Yük",
      responseReceived: "Alınan Yanıt",
      noData: "Veri yok",
      close: "Kapat",
      loadError: "n8n kayıtları yüklenirken hata",
      detailError: "Detaylar yüklenirken hata",
      of: "/",
    },
    flowBuilderN8N: {
      integrations: "Entegrasyonlar",
      webhookName: "n8n Webhook",
      webhookDesc: "n8n webhook'una veri gönder",
      waitName: "n8n Bekle",
      waitDesc: "n8n dönüşüne kadar duraklat",
      queryName: "n8n Sorgu",
      queryDesc: "n8n üzerinden veri getir",
      sendMessageName: "n8n Mesaj",
      sendMessageDesc: "n8n'den metin al ve gönder",
    },
    n8nMenuLabel: "n8n İzleme",
    hardcoded: {
      flowSavedSuccess: "Akış başarıyla kaydedildi",
      flowSaveError: "Akış kaydedilirken hata oluştu",
      flowDeletedSuccess: "Akış başarıyla silindi",
      flowDefaultsUpdated: "Varsayılan akışlar güncellendi",
      mediaError: "Medya işlenirken hata oluştu",
      noDataFound: "Veri bulunamadı",
      selectFollowUp: "Bir Follow Up seçin",
      noPermission: "Bu şirketin bu sayfaya erişim izni yok! Yönlendiriliyor.",
      noPermissionShort: "Bu şirketin bu sayfaya erişim izni yok!",
      loadError: "Gönderim verileri yüklenirken hata oluştu",
      generatingExcel: "Excel raporu oluşturuluyor, lütfen bekleyin...",
      loadingData: "Veriler yükleniyor... {{count}} kayıt bulundu",
      noDataToExport: "Dışa aktarılacak veri bulunamadı",
      excelReportHeader: "Kampanya Raporu",
      excelCampaignLabel: "Kampanya: {{name}}",
      excelGeneratedAt: "Oluşturma tarihi: {{date}}",
      excelColId: "ID",
      excelColRecipient: "Alıcı",
      excelColMessage: "Mesaj",
      excelColSentAt: "Gönderilme",
      excelColDeliveredAt: "Teslim edilme",
      excelColStatus: "Durum",
      excelDelivered: "Teslim edildi",
      excelPending: "Beklemede",
      excelSheetName: "Kampanya Raporu",
      excelSuccess: "Excel raporu başarıyla oluşturuldu! {{count}} kayıt dışa aktarıldı.",
      excelError: "Excel raporu oluşturulurken hata",
      settingsSaved: "Ayarlar kaydedildi",
      campaignDeleted: "Kampanya başarıyla silindi",
      enterToken: "Kimlik doğrulama tokenını girin",
      requestSuccess: "✅ İstek başarıyla gönderildi",
      requestLoaded: "İstek yüklendi — tekrarlamak için Gönder'e tıklayın",
      historyCleared: "Geçmiş temizlendi",
      copied: "Kopyalandı!",
      invalidJson: "Geçersiz JSON",
      chatCreated: "Sohbet başarıyla oluşturuldu!",
      chatsGenerated: "Sohbetler başarıyla oluşturuldu!",
      confirmBackfill: "Tüm mevcut kullanıcılar için sohbet oluşturmak istediğinizden emin misiniz? Bu zaman alabilir ve çok sayıda sohbet oluşturabilir.",
      walletNotFound: "Cüzdan bulunamadı",
      maxButtonsReached: "Maksimum 3 butona izin verilir",
      schedulesUpdated: "Programlar başarıyla güncellendi.",
      pushDeactivateError: "Push bildirimlerini devre dışı bırakırken hata",
      metaUpdated: "{{field}} güncellendi!",
      clickSaveToRegister: "Değişiklikleri kaydetmek için kaydet'e tıklayın",
      contactsImported: "WhatsApp kişileri başarıyla içe aktarıldı!",
      couldNotLoadRecords: "Kayıt listesi yüklenemedi",
      selectPeriod: "Lütfen dönemi seçin",
      fillAllFields: "Tüm alanları geçerli sayısal değerlerle doldurun.",
      slaLimitsOrder: "Sınırlar artan sırada olmalıdır: Yeşil < Sarı < Kırmızı.",
      slaUpdated: "SLA ayarları başarıyla güncellendi!",
      slaError: "SLA ayarları kaydedilirken hata oluştu.",
      cancelRequested: "İptal talep edildi. Mevcut sohbetin bitmesini bekleyin...",
      parameterizeFilter: "Filtre parametrelerini ayarlayın",
      intervalValue: "Aralık Değeri",
      sendHowManyTimes: "Kaç kez gönderilsin",
      sendNormallyNonBusiness: "İş günü olmayan günlerde normal gönder",
      sendBusinessDayBefore: "Bir iş günü önce gönder",
      sendBusinessDayAfter: "Bir iş günü sonra gönder",
      showUser: "Kullanıcıyı Göster",
      users: "Kullanıcılar",
      createTicket: "Bilet Oluştur",
      filterByTags: "Etiketlere Göre Filtrele",
      unknown: "Bilinmiyor",
      accessTicket: "Bilete Eriş",
      downloadFile: "Dosyayı indir",
      clickToDownload: "📎 İndirmek için tıklayın",
      select: "Seç",
      options: "Seçenekler",
      reviewAndPay: "İncele ve öde",
      followUpInfo: "Follow UP hakkında bilgi",
      followUpPanel: "Follow UP Paneli",
      aboutFollowUpTitle: "Follow UP Sistemi Hakkında",
      aboutFollowUpDesc: "Follow UP, mesaj akışları oluşturmanıza ve bunları otomatik yürütme için bir kişiye veya bilete atamanıza olanak tanır.",
      aboutFollowUpSelect: "Başlamak için aktif bir şablon seçin. İstediğiniz zaman durdurabilirsiniz.",
      understood: "Anladım",
      noAgent: "Temsilci yok",
      salesReport: "Satış Raporu",
      startDate: "Başlangıç Tarihi",
      endDate: "Bitiş Tarihi",
      agent: "Temsilci",
      all: "Tümü",
      generating: "Oluşturuluyor...",
      generateReport: "Rapor Oluştur",
      totalSales: "Toplam Satış",
      totalSalesValue: "Toplam Satış Değeri",
      nonSales: "Satış Dışı",
      avgTicketsPerAgent: "Temsilci Başına Ortalama Bilet",
      nonSaleReasons: "Satış Dışı Nedenleri",
      closedTickets: "Kapatılan Biletler",
      saleValue: "Satış Değeri",
      nonSaleReason: "Satış Dışı Nedeni",
      closingReason: "Kapatma Nedeni",
      closingReasonFilter: "Kapatma Nedeni",
      nonSaleReasonFilter: "Satış Dışı Nedeni",
      agentPerformance: "Temsilci Performansı",
      totalTickets: "Toplam Biletler",
      avgTickets: "Ortalama Biletler",
      date: "Tarih",
      allowCrossQueueTicket: "Herhangi bir sektörde/bağlantıda bilet açmaya izin ver",
      refresh: "Yenile",
      openNewTab: "Yeni sekmede aç",
      whatsappConnection: "WhatsApp Bağlantısı",
      tagUsed: "Kullanılan Etiket",
      notSpecified: "Belirtilmemiş",
      downloadSampleSheet: "Örnek Tablo İndir",
      saveFlow: "Akışı Kaydet",
      intervals: "Aralıklar",
      connected: "Bağlandı",
      connecting: "Bağlanıyor...",
      unknownNumber: "Bilinmeyen numara",
      incomingCall: "Gelen arama",
      readyForCalls: "Aramalar için hazır",
      connectingToServer: "Sunucuya bağlanıyor...",
      minimize: "Küçült",
      backspace: "Sil",
      unmute: "Sesi aç",
      mute: "Sessize al",
      endCall: "Bitir",
      answerCall: "Cevapla",
      rejectCall: "Reddet",
      makeCall: "Ara",
      typeNumberToCall: "Aramak için numara yazın",
      calling: "Aranıyor...",
      inCall: "Aramada",
      numberTooShort: "Numara çok kısa",
      numberTooLong: "Numara çok uzun",
      callError: "Arama yapılırken hata",
      recordAudio: "Ses Kaydet",
      recording: "Kaydediliyor...",
      audioRecorded: "Ses kaydedildi",
      confirmOrDelete: "Onaylamak için ✓ veya silmek için 🗑️ tıklayın",
      dashboardSubtitle: "Follow-up akışlarınızın ilerlemesini takip edin",
      totalContacts: "Toplam Kişiler",
      active: "Aktif",
      paused: "Duraklatılmış",
      withErrors: "Hatalı",
      steps: "Adımlar",
      completionRate: "Tamamlanma Oranı",
      responseRate: "Yanıt Oranı",
      contactDistribution: "Adıma göre kişi dağılımı",
      searchContact: "Kişi ara...",
      allChannels: "Tüm kanallar",
      allFilter: "Tümü",
      withErrorsFilter: "Hatalı",
      pausedFilter: "Duraklatılmış",
      noContact: "Kişi yok",
      noStepFound: "Adım bulunamadı",
      noHistoryFound: "Geçmiş bulunamadı",
      lastSendError: "Son gönderimde hata",
      step: "Adım",
      resume: "Devam et",
      pause: "Duraklat",
      history: "Geçmiş",
      timelineFollowUp: "Follow Up Zaman Çizelgesi",
      created: "Oluşturuldu",
      sent: "Gönderildi",
      next: "Sonraki",
      inactive: "Pasif",
      deliveryStatus: "Teslimat Durumu",
      delivered: "Teslim Edildi",
      waiting: "Bekliyor",
      failures: "Başarısız",
      messagesSent: "Gönderilen Mesajlar",
      uniqueRecipients: "Benzersiz Alıcılar",
      messagesDelivered: "Teslim Edilen Mesajlar",
      messageDetails: "Mesaj Detayları",
      exportExcel: "Excel Dışa Aktar",
      rowsPerPage: "Sayfa başına satır:",
      chipDelivered: "Teslim Edildi",
      chipPending: "Beklemede",
      chipFailed: "Başarısız",
      chipUnknown: "Bilinmiyor",
      loading: "Yükleniyor...",
      noMessagesFound: "Mesaj bulunamadı",
      notScheduled: "Planlanmadı",
      notCompleted: "Tamamlanmadı",
      approved: "Onaylandı",
      pending: "Beklemede",
      rejected: "Reddedildi",
      noContactInList: "Bu listede henüz kişi yok.",
      importViaExcelOrWhatsapp: "Yukarıdaki düğmeleri kullanarak Excel veya WhatsApp'tan içe aktarın.",
      loadingTags: "Etiketler yükleniyor...",
      noTagAvailable: "Etiket mevcut değil.",
      selectAllShown: "Tümünü seç ({{count}} gösterilen)",
      noContactFound: "Kişi bulunamadı.",
      trySearchOther: "Başka bir ad veya numara ile aramayı deneyin.",
      clickNewListToStart: "Başlamak için \"Yeni Liste\" tıklayın.",
      filterByTag: "Etikete göre filtrele:",
      clearTags: "Temizle ({{count}})",
      addingToList: "Listeye ekleniyor:",
      addToList: "{{count}} listeye ekle",
      listCreatedImport: "\"{{name}}\" listesi oluşturuldu! Şimdi kişileri içe aktarın (isteğe bağlı).",
      dragExcelHere: "Excel dosyasını buraya sürükleyin veya seçmek için tıklayın",
      acceptedFormats: "Kabul edilen formatlar: .xls, .xlsx",
      downloadTemplate: "📥 Şablon tabloyu indir (.xlsx)",
      skipImport: "İçe aktarmayı atla",
      nameListHint: "Bu kişi listesini tanımlamak için bir ad verin.",
      characters: "karakter",
      listNameMinLength: "Ad en az 2 karakter olmalıdır.",
      listCreatedSuccess: "\"{{name}}\" listesi başarıyla oluşturuldu!",
      contactsAddedToList: "{{count}} kişi \"{{name}}\" listesine eklendi!",
      listSelectedForCampaign: "\"{{name}}\" listesi kampanya için seçildi!",
      backToCampaign: "Kampanyaya Dön →",
      excelModel: "Excel Şablonu",
      importExcel: "Excel İçe Aktar",
      loadMore: "Daha fazla yükle",
      contactLists: "Kişi Listeleri",
      contactListsSubtitle: "Listeler oluşturun, kişileri içe aktarın ve bu kampanyada kullanılacak listeyi seçin.",
      simpleList: "Basit Liste",
      newListExcel: "Yeni Liste + Excel",
      selectedListLabel: "Seçilen liste: {{name}}",
      selectedListDesc: "{{count}} kişi — bu liste kampanyada kullanılacak",
      remove: "Kaldır",
      deleteListConfirm: "\"{{name}}\" listesini silmek istiyor musunuz?",
      addCaption: "Bir açıklama ekleyin (isteğe bağlı)",
      previewNotAvailable: "Önizleme mevcut değil",
      departments: "Departmanlar",
      name: "Ad",
      noTagFound: "Etiket bulunamadı. Yeni oluşturmak için yazın.",
      selectWhatsappConnection: "Kişileri içe aktarmak istediğiniz WhatsApp bağlantısını seçin:",
      noWhatsappConnectionFound: "Bağlı WhatsApp bağlantısı bulunamadı.",
      cancel: "İptal",
      import: "İçe Aktar",
      imageNotAvailable: "Görüntü mevcut değil",
    },
    todoList: {
      title: "Yapılacaklar Listesi",
      counter: "{{pending}} bekleyen / {{total}} görev",
      newTask: "Yeni görev",
      editTask: "Görevi düzenle",
      add: "Ekle",
      save: "Kaydet",
      cancel: "İptal",
      priority: "Öncelik",
      category: "Kategori",
      status: "Durum",
      dueDate: "Son tarih",
      assignTo: "Atama",
      nobody: "Kimse",
      notes: "Notlar",
      notesLabel: "Notlar",
      search: "Ara...",
      allTabs: "Tümü",
      pendingTabs: "Bekleyen",
      doneTabs: "Tamamlanan",
      allPriorities: "Tümü",
      allUsers: "Tümü",
      sortBy: "Sırala",
      sortCreatedAt: "Oluşturma tarihi",
      sortPriority: "Öncelik",
      sortDueDate: "Son tarih",
      sortManual: "Manuel (sürükle)",
      user: "Kullanıcı",
      priorities: { high: "Yüksek", medium: "Orta", low: "Düşük" },
      statuses: { pending: "Beklemede", in_progress: "Devam Ediyor", done: "Tamamlandı" },
      categories: { general: "Genel", work: "İş", personal: "Kişisel", urgent: "Acil", study: "Çalışma" },
      emptyNoTasks: "Henüz görev oluşturulmadı",
      emptyFiltered: "Görev bulunamadı",
      emptyAddFirst: "İlk görevinizi yukarıdan ekleyin!",
      emptyAdjustFilters: "Filtreleri ayarlamayı deneyin",
      dueSoonAlert: "görev yakında sona eriyor:",
      overdue: "Gecikmiş!",
      subtasks: "Alt görevler",
      newSubtask: "Yeni alt görev...",
      createdBy: "Oluşturan",
      assignedTo: "Atanan",
      deleteTitle: "Silmeyi onayla",
      deleteMessage: "Bu görevi silmek istediğinizden emin misiniz?",
      deleteConfirm: "Sil",
      toasts: {
        loadError: "Görevler yüklenirken hata",
        saveError: "Görev kaydedilirken hata",
        statusError: "Durum güncellenirken hata",
        deleteError: "Görev silinirken hata",
        subtaskError: "Alt görevler güncellenirken hata",
      },
    },
    accountSwitch: {
      title: "Hesaplarınız",
      subtitle: "Otomatik geçiş için bir hesap seçin",
      addAccount: "Hesap ekle",
      savePassword: "Şifre Kaydet",
      saveCurrentPassword: "Mevcut Hesap Şifresini Kaydet",
      email: "E-posta",
      password: "Şifre",
      cancel: "İptal",
      save: "Kaydet",
      admin: "Yönetici",
      agent: "Temsilci",
      saved: "Kaydedildi",
      noPassword: "Şifre yok",
      active: "AKTİF",
      passwordHelper: "Şifre hızlı geçiş için yerel olarak saklanır",
      saveWarning: "Hızlı geçişi etkinleştirmek için şifrenizi kaydedin",
      toasts: {
        accountAdded: "Hesap doğrulandı ve eklendi!",
        invalidCredentials: "Geçersiz kimlik bilgileri. E-posta ve şifreyi kontrol edin.",
        passwordSaved: "Şifre başarıyla kaydedildi!",
        cannotRemoveActive: "Aktif hesap kaldırılamaz.",
        accountRemoved: "Hesap kaldırıldı.",
        noCredentials: "Kimlik bilgileri kaydedilmedi. Önce şifreyi kaydedin.",
        connectedAs: "{{name}} olarak bağlanıldı",
      },
    },
    campaignModal: {
      followUp: {
        useApprovedTemplate: "Onaylı şablon kullan",
        noSimpleTemplate: "Uygun basit şablon yok",
        selectApprovedTemplate: "Onaylı bir şablon seçin",
        simpleTemplateHelper: "Burada yalnızca değişkensiz onaylı şablonlar görünür. Başlık medyası (varsa) şablonun parçasıdır.",
        metaRestrictionTitle: "Meta kısıtlaması — 24 saat penceresi",
        metaRestrictionBody: "Resmi API kampanyasında ek mesajları (2-5) doldurdunuz. Meta, bu mesajların yalnızca müşteri ilk şablona yanıt verdikten sonra ve 24 saatlik pencere içinde gönderilmesine izin verir.",
        metaRestrictionEnableHint: "Aşağıdaki \"Şablondan sonra mesaj gönder\" anahtarını etkinleştirin; aksi takdirde 2-5 mesajları gönderilmez.",
      },
    },
    campaignReport: {
      awaitingTemplateResponseCard: "Şablon yanıtı bekleniyor",
      templateRespondedCard: "Yanıtladı (takip gönderildi)",
      followUpStatus: {
        waiting: "Yanıt bekleniyor",
        waitingTooltip: "Şablon gönderildi. 2-5 mesajlarını açmak için müşterinin yanıt vermesi bekleniyor (Meta'nın 24 saat penceresi).",
        sent: "Takipler gönderildi",
        sentTooltip: "Müşteri şablonu yanıtladı. Takip mesajları (2-5) zaten gönderildi.",
        expired: "Pencere doldu",
        expiredTooltip: "Meta'nın 24 saat penceresi müşteri yanıtı olmadan doldu. 2-5 mesajları artık gönderilemez.",
      },
    },
    showTicketLogModal: {
      title: {
        header: "Logs",
      },
      options: {
        create: "Ticket oluşturuldu.",
        chatBot: "ChatBot başlatıldı.",
        queue: " - Kuyruk atandı.",
        open: " hizmeti başlattı.",
        access: "bileti erişti.",
        transfered: "bileti aktardı.",
        receivedTransfer: "aktarılan bileti aldı.",
        pending: "kuyruğa geri döndü.",
        closed: "bileti kapattı",
        reopen: "bileti yeniden açtı",
        redirect: "- yönlendirildi",
        clientClosed: "İstemci bileti kapattı",
      },
      close: "Kapat",
    },
    showTicketOpenModal: {
      close: "Kapat",
    },
  },
};

export { messages };
